const addToCartButton = document.querySelector('.btn.btn--full.add-to-cart'); 
document.addEventListener('DOMContentLoaded',()=>
{
  const desc = document.getElementById("collectionDesc");
  const btn = document.getElementById("toggleDesc");
  const wrapper = btn ? btn.closest('.collection-description') : null;

  if (!desc || !btn) return;

  const fullText = desc.textContent.trim();
  const maxLength = 120;

  if (fullText.length > maxLength) {
    const shortText = fullText.slice(0, maxLength);
    desc.textContent = shortText;

    btn.addEventListener("click", function() {
      const isMore = btn.textContent === "Read more";
      if (isMore) {
        desc.textContent = fullText;
        btn.textContent = "Read less";
        if (wrapper) wrapper.classList.add('is-expanded');
      } else {
        desc.textContent = shortText;
        btn.textContent = "Read more";
        if (wrapper) wrapper.classList.remove('is-expanded');
      }
    });
  } else {
    btn.style.display = "none";
  }
})

document.addEventListener("DOMContentLoaded", () => {
  const url_variant = new URL(window.location.href);
  const url_variantId = url_variant.searchParams.get("variant");
  if (!url_variantId) return;

  const radio = document.querySelector(`input[data-variant-id="${url_variantId}"]`); 
  if (!radio) return;
  radio.checked = true;
  radio.dispatchEvent(new Event("change", { bubbles: true }));

  function updateUiForVariant(variant) {
    const buyButton = document.querySelector('#gokwik-buy-now');
    const notifyBtn = document.querySelector('.notify_fun_off');
    const addToCart = document.querySelector('[name="add"]');

    if (!variant) return;

    if (variant.available) {
      if (buyButton) buyButton.style.display = 'block';
      if (notifyBtn) notifyBtn.style.display = 'none';
      if (addToCart) addToCart.style.display = 'block';
    } else {
      if (buyButton) buyButton.style.display = 'none';
      if (notifyBtn) notifyBtn.style.display = 'block';
      if (addToCart) addToCart.style.display = 'none';
    }
  }

  function getVariantById(id) {
    return window.productVariants?.find(v => v.id == id);
  }

  const url = new URL(window.location.href);
  const variantId = url.searchParams.get("variant");

  if (variantId) {
    const radio = document.querySelector(`input[data-variant-id="${variantId}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));

      const variant = getVariantById(variantId);
      updateUiForVariant(variant);
    }
  }

  const allRadios = document.querySelectorAll("input[data-variant-id]");

  allRadios.forEach(radio => {
    radio.addEventListener("change", (e) => {
      const vid = e.target.dataset.variantId;
      const variant = getVariantById(vid);

      if (!variant) return;

      // Update URL without reload
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", vid);
      window.history.replaceState({}, "", newUrl.toString());

      // Update UI
      updateUiForVariant(variant);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  console.log("Notify Me & Pre-Order script loaded");
  
  let isPopupOpen = false;
  let isSubmitting = false;
  
  // ========================================
  // PRE-ORDER BUTTON CLICK HANDLER
  // ========================================
  document.addEventListener('click', function(event) {
    console.log("event", event.target);
    const preorderButton = event.target.closest('.preorder_desktop-pdp-button'); 
    console.log("preorderButton", preorderButton);
    if (!preorderButton) return;
    
    event.preventDefault();
    event.stopPropagation();
    
    if (isPopupOpen) {
      console.log('Popup already open, ignoring click');
      return;
    }
    
    console.log('🎯 Pre-order button clicked');
    
    // Find the PRE-ORDER popup (using specific class)
    let preorderPopup = null;
    const gridProductContent = preorderButton.closest('.grid-product__content');
    
    if (gridProductContent) {
      preorderPopup = gridProductContent.querySelector('.preorder_popup_container');
      console.log("Collection page structure - looking for preorder popup");
    }
    
    if (!preorderPopup) {
      const paymentCustomBtn = preorderButton.closest('.payment_custom_btn');
      if (paymentCustomBtn) {
        preorderPopup = paymentCustomBtn.querySelector('.preorder_popup_container');
        console.log("Product page structure - looking for preorder popup");
      }
    }
    
    if (!preorderPopup) {
      preorderPopup = document.querySelector('.preorder_popup_container');
      console.log("Using first preorder popup on page");
    }
    
    console.log("Preorder popup found:", !!preorderPopup);
    
    if (!preorderPopup) {
      console.error('❌ Preorder popup container not found');
      return;
    }
    
    isPopupOpen = true;
    preorderPopup.classList.add('active');
    preorderPopup.style.display = 'flex';
    document.body.classList.add('overlay_bulkpopup');
    
    const closePopupButton = preorderPopup.querySelector('.notify_close_popup');
    const thankYouMessage = preorderPopup.querySelector('#preorder_thank_you');
    const formState = preorderPopup.querySelector('.notify-popup-scroller');
    
    if (thankYouMessage) thankYouMessage.style.display = 'none';
    if (formState) formState.style.display = 'block';
    if (closePopupButton) closePopupButton.style.display = 'block';
    
    const errorMessages = preorderPopup.querySelectorAll('.error-message');
    errorMessages.forEach(msg => msg.remove());
    const invalidFields = preorderPopup.querySelectorAll('.invalid');
    invalidFields.forEach(field => field.classList.remove('invalid'));
    
    isSubmitting = false;
    
    const productId = preorderButton.getAttribute('data-product-id');
    const variantId = preorderButton.getAttribute('data-variant-id');
    const productTitle = preorderButton.getAttribute('data-product-title');
    const variantTitle = preorderButton.getAttribute('data-variant-title');
    const variantSku = preorderButton.getAttribute('data-variant-sku');
    
    console.log('Pre-order product data:', { productId, variantId, productTitle, variantTitle, variantSku });
    
    const productNameElement = preorderPopup.querySelector('.product-title');
    if (productNameElement && productTitle) {
      productNameElement.textContent = productTitle.toUpperCase();
    }
    
    const preorderForm = preorderPopup.querySelector('form#ContactForm-NotifyFun');
    if (preorderForm) {
      const pidInput = preorderForm.querySelector('input[name="contact[Product ID]"]');
      const vidInput = preorderForm.querySelector('input[name="contact[Variant ID]"]');
      const pnameInput = preorderForm.querySelector('input[name="contact[Product Name]"]');
      const vnameInput = preorderForm.querySelector('input[name="contact[Variant Name]"]');
      const vskuInput = preorderForm.querySelector('input[name="contact[Variant SKU]"]');
      
      if (pidInput && productId) pidInput.value = productId;
      if (vidInput && variantId) vidInput.value = variantId;
      if (pnameInput && productTitle) pnameInput.value = productTitle;
      if (vnameInput && variantTitle) vnameInput.value = variantTitle;
      if (vskuInput && variantSku) vskuInput.value = variantSku;
    }
  });
  
  // ========================================
  // NOTIFY ME BUTTON CLICK HANDLER
  // ========================================
  document.addEventListener('click', function(event) {
    let notifyTrigger = event.target.closest('.notify-button, .notify_desktop-pdp-button, .notify-me-varint-popup');
    
    if (!notifyTrigger) return;
    
    let notifyButton = notifyTrigger;
    if (notifyTrigger.classList.contains('notify-me-varint-popup')) {
      // Check if the actual clicked element is a button
      const clickedButton = event.target.closest('.notify-button, .notify_desktop-pdp-button');
      if (clickedButton) {
        notifyButton = clickedButton;
      } else {
        // If clicking on container, prefer .notify-button (the actual button) over .notify_desktop-pdp-button (the link)
        notifyButton = notifyTrigger.querySelector('.notify-button') || notifyTrigger.querySelector('.notify_desktop-pdp-button');
        if (!notifyButton) {
          console.warn('Notify trigger container found but no button inside');
          return;
        }
      }
    }
    
    event.preventDefault();
    event.stopPropagation();
    
    if (isPopupOpen) {
      console.log('Popup already open, ignoring click');
      return;
    }
    
    console.log('🔔 Notify Me button clicked');
    
    // Find the NOTIFY ME popup (using specific class)
    let notifyPopup = null;
     const mainFormPopup = document.querySelector(
      '.product-single__form .notifyme_popup_container'
    );
    console.log("mainFormPopup: ", mainFormPopup);
    if (mainFormPopup) {
      notifyPopup = mainFormPopup;
    }
  let isInsideProductSlider = event.target.closest('.product-slider');
  if (isInsideProductSlider) {
        const searchDrawerNotifyPopup = document.querySelector('.notifyme_popup_container.search-drawer');
        if (searchDrawerNotifyPopup) {
          notifyPopup = searchDrawerNotifyPopup;
  
          const productItem = notifyButton.closest('.grid-product__content') || notifyButton.closest('.grid-product');
          const originalImg = productItem ? productItem.querySelector('img') : null;
          const popupImg = notifyPopup.querySelector('img.popup-product-image') || notifyPopup.querySelector('.product-image img') || notifyPopup.querySelector('img');
  
          if (originalImg && popupImg) {
            popupImg.src = originalImg.currentSrc || originalImg.src;
            if (originalImg.srcset) popupImg.srcset = originalImg.srcset;
          }                
        }
      }
    const gridProductContent = notifyButton.closest('.grid-product__content');  
    if (gridProductContent && !notifyPopup) {
      notifyPopup = gridProductContent.querySelector('.notifyme_popup_container');
      console.log("Collection page structure - looking for notify popup");
    }
    
    if (!notifyPopup) {
      const paymentCustomBtn = notifyButton.closest('.payment_custom_btn');
      if (paymentCustomBtn) {
        notifyPopup = paymentCustomBtn.querySelector('.notifyme_popup_container');
        console.log("Product page structure - looking for notify popup");
      }
    }
    
    if (!notifyPopup) {
      notifyPopup = document.querySelector('.notifyme_popup_container');
      console.log("Using first notify popup on page");
    }
    
    console.log("Notify popup found:", !!notifyPopup);
    
    if (!notifyPopup) {
      console.error('❌ Notify popup container not found');
      return;
    }
    
    isPopupOpen = true;
    notifyPopup.classList.add('active');
    notifyPopup.style.display = 'flex';
    document.body.classList.add('overlay_bulkpopup');
    
    const closePopupButton = notifyPopup.querySelector('.notify_close_popup');
    // Reset all possible thank you messages (for different page types)
    const thankYouMessages = notifyPopup.querySelectorAll('#notify_thank_you, #thank_you, #preorder_thank_you');
    const formState = notifyPopup.querySelector('.notify-popup-scroller');
    
    // Hide all thank you messages and show form
    thankYouMessages.forEach(msg => {
      msg.style.display = 'none';
    });
    if (formState) formState.style.display = 'block';
    if (closePopupButton) closePopupButton.style.display = 'block';
    
    // Clear any auto-close timers from previous submissions
    if (notifyPopup.dataset.autoCloseTimer) {
      clearTimeout(parseInt(notifyPopup.dataset.autoCloseTimer));
      delete notifyPopup.dataset.autoCloseTimer;
    }
    
    const errorMessages = notifyPopup.querySelectorAll('.error-message');
    errorMessages.forEach(msg => msg.remove());
    const invalidFields = notifyPopup.querySelectorAll('.invalid');
    invalidFields.forEach(field => field.classList.remove('invalid'));
    
    isSubmitting = false;
    
    // Get variant ID from button or from currently checked radio
    let variantId = notifyButton.getAttribute('data-variant-id');
    if (!variantId) {
      const checkedRadio = document.querySelector('input[data-variant-id]:checked');
      if (checkedRadio && checkedRadio.dataset.variantId) {
        variantId = checkedRadio.dataset.variantId;
      }
    }
    
    const productId = notifyButton.getAttribute('data-product-id');
    const productTitle = notifyButton.getAttribute('data-product-title');
    let variantTitle = notifyButton.getAttribute('data-variant-title');
    let variantSku = notifyButton.getAttribute('data-variant-sku');
    
    // If SKU is missing from the selected button, try to get it from other buttons in the same container
    if (!variantSku && notifyTrigger.classList.contains('notify-me-varint-popup')) {
      const allButtons = notifyTrigger.querySelectorAll('.notify-button, .notify_desktop-pdp-button');
      for (let btn of allButtons) {
        const sku = btn.getAttribute('data-variant-sku');
        if (sku) {
          variantSku = sku;
          if (!variantTitle) variantTitle = btn.getAttribute('data-variant-title');
          if (!variantId) variantId = btn.getAttribute('data-variant-id');
          break;
        }
      }
    }
    
    // If SKU is still missing, try to find it from the size label that matches the variant ID
    if (!variantSku && variantId) {
      const gridProductContent = notifyButton.closest('.grid-product__content');
      if (gridProductContent) {
        // Find the size label with matching variant ID
        const sizeLabel = gridProductContent.querySelector(`label.size-label[data-variant-id="${variantId}"]`);
        if (sizeLabel) {
          // Get the notify button from this size label
          const sizeNotifyButton = sizeLabel.querySelector('.notify-button[data-variant-id="' + variantId + '"], .notify_desktop-pdp-button[data-variant-id="' + variantId + '"]');
          if (sizeNotifyButton) {
            const sku = sizeNotifyButton.getAttribute('data-variant-sku');
            if (sku) {
              variantSku = sku;
              if (!variantTitle) variantTitle = sizeNotifyButton.getAttribute('data-variant-title');
            }
          }
        }
        
        // Also check all size labels in the same product for any button with this variant ID
        if (!variantSku) {
          const allSizeLabels = gridProductContent.querySelectorAll('label.size-label');
          for (let label of allSizeLabels) {
            if (label.getAttribute('data-variant-id') == variantId) {
              const labelButtons = label.querySelectorAll('.notify-button, .notify_desktop-pdp-button');
              for (let btn of labelButtons) {
                if (btn.getAttribute('data-variant-id') == variantId) {
                  const sku = btn.getAttribute('data-variant-sku');
                  if (sku) {
                    variantSku = sku;
                    if (!variantTitle) variantTitle = btn.getAttribute('data-variant-title');
                    break;
                  }
                }
              }
              if (variantSku) break;
            }
          }
        }
      }
    }
    
    // If SKU is still missing, try to get it from variant data
    if (!variantSku && variantId) {
      // Try to get from window.productVariants
      if (window.productVariants && Array.isArray(window.productVariants)) {
        const variant = window.productVariants.find(v => v.id == variantId);
        if (variant) {
          variantSku = variant.sku || '';
          if (!variantTitle) variantTitle = variant.title || '';
        }
      }
      
      // Fallback: Try to get from product JSON in the grid item
      if (!variantSku) {
        const gridProductContent = notifyButton.closest('.grid-product__content');
        if (gridProductContent) {
          const productJson = gridProductContent.querySelector('[data-product-json]');
          if (productJson) {
            try {
              const product = JSON.parse(productJson.textContent);
              const variant = product.variants.find(v => v.id == variantId);
              if (variant) {
                variantSku = variant.sku || '';
                if (!variantTitle) variantTitle = variant.title || '';
              }
            } catch (e) {
              console.warn('Error parsing product JSON:', e);
            }
          }
        }
        
        // Fallback: Try global product JSON
        if (!variantSku) {
          const productJson = document.querySelector('[data-product-json]');
          if (productJson) {
            try {
              const product = JSON.parse(productJson.textContent);
              const variant = product.variants.find(v => v.id == variantId);
              if (variant) {
                variantSku = variant.sku || '';
                if (!variantTitle) variantTitle = variant.title || '';
              }
            } catch (e) {
              console.warn('Error parsing product JSON:', e);
            }
          }
        }
      }
    }
    
    console.log('Notify Me product data:', { productId, variantId, productTitle, variantTitle, variantSku });
    
    // Log warning if SKU is still missing after all attempts
    if (!variantSku && variantId) {
      console.warn('⚠️ Variant SKU not found for variant ID:', variantId, 'Product ID:', productId);
    }
    
    // Store variant data on the popup for later retrieval during form submission
    if (notifyPopup) {
      notifyPopup.dataset.variantSku = variantSku || '';
      notifyPopup.dataset.variantId = variantId || '';
      notifyPopup.dataset.variantTitle = variantTitle || '';
      notifyPopup.dataset.productId = productId || '';
      notifyPopup.dataset.productTitle = productTitle || '';
      
      // Store product handle for API fallback
      const gridProduct = notifyButton.closest('.grid-product');
      if (gridProduct) {
        const productHandle = gridProduct.getAttribute('data-product-handle');
        if (productHandle) {
          notifyPopup.dataset.productHandle = productHandle;
        }
      }
    }
    
    const productNameElement = notifyPopup.querySelector('.product-title');
    if (productNameElement && productTitle) {
      productNameElement.textContent = productTitle.toUpperCase();
    }
    
    const notifyForm = notifyPopup.querySelector('form#ContactForm-NotifyFun');
    if (notifyForm) {
      const pidInput = notifyForm.querySelector('input[name="contact[Product ID]"]');
      const vidInput = notifyForm.querySelector('input[name="contact[Variant ID]"]');
      const pnameInput = notifyForm.querySelector('input[name="contact[Product Name]"]');
      const vnameInput = notifyForm.querySelector('input[name="contact[Variant Name]"]');
      const vskuInput = notifyForm.querySelector('input[name="contact[Variant SKU]"]');
      
      if (pidInput && productId) pidInput.value = productId;
      if (vidInput && variantId) vidInput.value = variantId;
      if (pnameInput && productTitle) pnameInput.value = productTitle;
      if (vnameInput && variantTitle) vnameInput.value = variantTitle;
      if (vskuInput) vskuInput.value = variantSku || ''; // Always set SKU, even if empty
    }
  });
  
  // ========================================
  // HELPER FUNCTION TO CLOSE NOTIFY POPUP
  // ========================================
  function closeNotifyPopup(popup) {
    if (!popup) return;
    
    // Clear auto-close timer if exists
    if (popup.dataset.autoCloseTimer) {
      clearTimeout(parseInt(popup.dataset.autoCloseTimer));
      delete popup.dataset.autoCloseTimer;
    }
    
    // Hide popup
    popup.classList.remove('active');
    popup.style.display = 'none';
    document.body.classList.remove('overlay_bulkpopup');
    isPopupOpen = false;
    
    // Reset form state
    const thankYouMessage = popup.querySelector('#notify_thank_you, #preorder_thank_you');
    const formState = popup.querySelector('.notify-popup-scroller');
    const closePopupButton = popup.querySelector('.notify_close_popup');
    
    if (thankYouMessage) thankYouMessage.style.display = 'none';
    if (formState) formState.style.display = 'block';
    if (closePopupButton) closePopupButton.style.display = 'block';
    
    console.log('✅ Popup closed');
  }
  
  // ========================================
  // CLOSE POPUP HANDLERS
  // ========================================
  document.addEventListener('click', function(event) {
    // Check if clicked element is the close button or inside it (like an icon)
    const closeButton = event.target.closest('.notify_close_popup');
    if (!closeButton) return;
    
    event.preventDefault();
    event.stopPropagation();
    
    console.log('🔴 Close button clicked:', closeButton);
    
    // Find the popup container - it should be the parent of .notify-container
    let popup = closeButton.closest('.notify_popup_container');
    
    // If not found, try finding via notify-container parent
    if (!popup) {
      const notifyContainer = closeButton.closest('.notify-container');
      if (notifyContainer && notifyContainer.parentElement) {
        popup = notifyContainer.parentElement;
        // Verify it has the right class
        if (!popup.classList.contains('notify_popup_container')) {
          popup = null;
        }
      }
    }
    
    if (popup) {
      closeNotifyPopup(popup);
      console.log('✅ Popup closed via close button');
    } else {
      console.error('❌ Popup container not found for close button');
      console.log('Close button:', closeButton);
      console.log('Parent elements:', closeButton.parentElement);
      console.log('Notify container:', closeButton.closest('.notify-container'));
      console.log('Popup container:', closeButton.closest('.notify_popup_container'));
    }
  });
  
  document.addEventListener('click', function(event) {
    const closeThankYouButton = event.target.closest('.notify_close_btn');
    if (!closeThankYouButton) return;
    
    event.preventDefault();
    event.stopPropagation();
    
    console.log('🔴 Thank you close button clicked:', closeThankYouButton);
    
    // Find the popup container - it should be the parent of .notify-container
    let popup = closeThankYouButton.closest('.notify_popup_container');
    
    // If not found, try finding via notify-container parent
    if (!popup) {
      const notifyContainer = closeThankYouButton.closest('.notify-container');
      if (notifyContainer && notifyContainer.parentElement) {
        popup = notifyContainer.parentElement;
        // Verify it has the right class
        if (!popup.classList.contains('notify_popup_container')) {
          popup = null;
        }
      }
    }
    
    // Also check if it's inside a thank you div that's inside the popup
    if (!popup) {
      const thankYouDiv = closeThankYouButton.closest('#notify_thank_you, #preorder_thank_you');
      if (thankYouDiv) { 
        popup = thankYouDiv.closest('.notify_popup_container');
      }
    }
    
    if (popup) {
      closeNotifyPopup(popup);
      console.log('✅ Popup closed via thank you button');
    } else {
      console.error('❌ Popup container not found for thank you close button');
      console.log('Close button:', closeThankYouButton);
      console.log('Parent elements:', closeThankYouButton.parentElement);
      console.log('Thank you div:', closeThankYouButton.closest('#notify_thank_you, #preorder_thank_you'));
      console.log('Popup container:', closeThankYouButton.closest('.notify_popup_container'));
    }
  });
  
  // ========================================
  // FORM VALIDATION
  // ========================================
  document.addEventListener('input', function(event) {
    const field = event.target;
    if (!field.matches('input[type="text"], input[type="email"], input[type="tel"]')) return;
    if (!field.closest('form#ContactForm-NotifyFun')) return;
    
    field.classList.remove('invalid');
    const fieldContainer = field.closest('.field');
    if (fieldContainer) {
      const errorMessage = fieldContainer.querySelector('.error-message');
      if (errorMessage) errorMessage.remove();
    }
  });
  
  // ========================================
  // FORM SUBMISSION
  // ========================================
  document.addEventListener('click', function(event) {
    const sendButton = event.target.closest('#sendButton');
    if (!sendButton) return;
    
    const clonedForm = sendButton.closest('form#ContactForm-NotifyFun');
    if (!clonedForm) return;
    
    event.preventDefault();
    console.log("Send button clicked");
    
    if (isSubmitting) {
      console.log('Form submission already in progress');
      return;
    }
    
    const emailField = clonedForm.querySelector('[name="contact[email]"]');
    const email = emailField ? emailField.value : '';
    const vURL = clonedForm.querySelector('[name="contact[Product URL]"]')?.value || '';
    const pname = clonedForm.querySelector('[name="contact[Product Name]"]')?.value || '';
    const pid = clonedForm.querySelector('[name="contact[Product ID]"]')?.value || '';
    let vSKU = clonedForm.querySelector('[name="contact[Variant SKU]"]')?.value || '';
    const vname = clonedForm.querySelector('[name="contact[Variant Name]"]')?.value || '';
    const formname = clonedForm.querySelector('[name="contact[Form Type]"]')?.value || '';
    const variant_id = clonedForm.querySelector('[name="contact[Variant ID]"]')?.value || '';
    
    // If SKU is empty, try to get it from the popup's stored data (set when popup was opened)
    if (!vSKU) {
      const popup = sendButton.closest('.notify_popup_container');
      if (popup && popup.dataset.variantSku) {
        vSKU = popup.dataset.variantSku;
        // Update the form input
        const vskuInput = clonedForm.querySelector('[name="contact[Variant SKU]"]');
        if (vskuInput) vskuInput.value = vSKU;
        console.log('Retrieved SKU from popup data:', vSKU);
      }
    }
    
    // If SKU is still empty, try to find it from size labels in the DOM
    if (!vSKU && variant_id) {
      // Find the size label with matching variant ID in any grid product
      const sizeLabel = document.querySelector(`label.size-label[data-variant-id="${variant_id}"]`);
      if (sizeLabel) {
        // Get the notify button from this size label
        const sizeNotifyButton = sizeLabel.querySelector('.notify-button[data-variant-id="' + variant_id + '"], .notify_desktop-pdp-button[data-variant-id="' + variant_id + '"]');
        if (sizeNotifyButton) {
          const sku = sizeNotifyButton.getAttribute('data-variant-sku');
          if (sku) {
            vSKU = sku;
            // Update the form input
            const vskuInput = clonedForm.querySelector('[name="contact[Variant SKU]"]');
            if (vskuInput) vskuInput.value = vSKU;
            console.log('Retrieved SKU from size label button:', vSKU);
          }
        }
      }
    }
    
    // If SKU is still empty, try to get it from the current variant
    if (!vSKU && variant_id) {
      // Try to get from window.productVariants
      if (window.productVariants && Array.isArray(window.productVariants)) {
        const variant = window.productVariants.find(v => v.id == variant_id);
        if (variant && variant.sku) {
          vSKU = variant.sku;
          // Update the form input
          const vskuInput = clonedForm.querySelector('[name="contact[Variant SKU]"]');
          if (vskuInput) vskuInput.value = vSKU;
        }
      }
      
      // Fallback: Try to get from product JSON
      if (!vSKU) {
        const productJson = document.querySelector('[data-product-json]');
        if (productJson) {
          try {
            const product = JSON.parse(productJson.textContent);
            const variant = product.variants.find(v => v.id == variant_id);
            if (variant && variant.sku) {
              vSKU = variant.sku;
              // Update the form input
              const vskuInput = clonedForm.querySelector('[name="contact[Variant SKU]"]');
              if (vskuInput) vskuInput.value = vSKU;
            }
          } catch (e) {
            console.warn('Error parsing product JSON:', e);
          }
        }
      }
      
      // Last resort: Fetch variant data from Shopify API
      if (!vSKU && variant_id) {
        // Try to get product handle from the form or popup
        const popup = sendButton.closest('.notify_popup_container');
        const productHandle = popup?.dataset?.productHandle || document.querySelector(`[data-product-id="${pid}"]`)?.closest('.grid-product')?.getAttribute('data-product-handle');
        
        if (productHandle) {
          fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(product => {
              const variant = product.variants.find(v => v.id == variant_id);
              if (variant && variant.sku) {
                const vskuInput = clonedForm.querySelector('[name="contact[Variant SKU]"]');
                if (vskuInput) {
                  vskuInput.value = variant.sku;
                  console.log('Retrieved SKU from Shopify API:', variant.sku);
                }
              }
            })
            .catch(e => {
              console.warn('Error fetching product from Shopify API:', e);
            });
        }
      }
    }
    
    console.log('Form data:', { email, variant_id, pname, pid, vSKU, vname, formname, vURL });
    
    // Log warning if SKU is still missing before submission
    if (!vSKU && variant_id) {
      console.warn('⚠️ Variant SKU is missing for variant ID:', variant_id, 'Product ID:', pid);
      console.warn('Attempting to fetch from Shopify API...');
    }
    
    if (validateNotifyForm(clonedForm)) {
      isSubmitting = true;
      sendButton.disabled = true;
      sendButton.classList.add('btn--loading');
      
      let popup = sendButton.closest('.notify_popup_container');
      
      // If not found, try finding via form
      if (!popup) {
        popup = clonedForm.closest('.notify_popup_container');
      }
      
      // If still not found, try finding via notify-container
      if (!popup) {
        const notifyContainer = sendButton.closest('.notify-container');
        if (notifyContainer) {
          popup = notifyContainer.closest('.notify_popup_container');
        }
      }
      
      console.log('Popup found for form submission:', !!popup, popup);
      
      const isPreorder = popup?.classList.contains('preorder_popup_container');
      
      fetch('https://cpanel.mensabrands.com/Notifyme/public/userDataDL', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-type": "application/json",
          "Authorization": `Bearer ${window.sessionToken || ''}`
        },
        body: JSON.stringify({
          customer_email: email,
          variant_id: variant_id,
          product_name: pname,
          form_type: formname,
          product_id: pid,
          variant_SKU: vSKU,
          variant_name: vname,
          url: vURL  
        })
      })
      .then(async response => {
        // Check if response is ok
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // Try to parse as JSON, but handle non-JSON responses
        try {
          const data = await response.json();
          return data;
        } catch (e) {
          // If not JSON, just return empty object
          console.log('Response is not JSON, continuing anyway');
          return {};
        }
      })
      .then(data => {
        console.log('Form submitted successfully', data);
        if (popup) {
          console.log('Popup element:', popup, 'Classes:', popup.className);
          
          // Try multiple selectors to find thank you message (different IDs on different pages)
          let thankYouMessage = null;
          
          // First, try to find by ID directly in popup
          if (isPreorder) {
            thankYouMessage = popup.querySelector('#preorder_thank_you');
          } else {
            // Try notify_thank_you first (product grid item), then thank_you (PDP page)
            thankYouMessage = popup.querySelector('#notify_thank_you') || popup.querySelector('#thank_you');
          }
          
          console.log('After ID search:', !!thankYouMessage);
          
          // If not found, search in notify-container (where it actually is in product-grid-item)
          if (!thankYouMessage) {
            const notifyContainer = popup.querySelector('.notify-container');
            console.log('Notify container found:', !!notifyContainer);
            if (notifyContainer) {
              if (isPreorder) {
                thankYouMessage = notifyContainer.querySelector('#preorder_thank_you');
              } else {
                thankYouMessage = notifyContainer.querySelector('#notify_thank_you') || notifyContainer.querySelector('#thank_you');
              }
              console.log('After container search:', !!thankYouMessage);
            }
          }
          
          // Fallback: search by class if ID not found
          if (!thankYouMessage) {
            thankYouMessage = popup.querySelector('.thank-you-message');
            if (!thankYouMessage) {
              const notifyContainer = popup.querySelector('.notify-container');
              if (notifyContainer) {
                thankYouMessage = notifyContainer.querySelector('.thank-you-message');
              }
            }
            if (!thankYouMessage) {
              thankYouMessage = popup.querySelector('.form-status-list, .form-status');
            }
            console.log('After class search:', !!thankYouMessage);
          }
          
          // Last resort: search from the form/clonedForm
          if (!thankYouMessage) {
            const formParent = clonedForm.closest('.notify_popup_container');
            if (formParent) {
              thankYouMessage = formParent.querySelector('#notify_thank_you, #thank_you, #preorder_thank_you');
              console.log('After form parent search:', !!thankYouMessage);
            }
          }
          
          // Even more aggressive: search in the entire document for this specific popup's thank you
          if (!thankYouMessage) {
            // Get the popup's data attributes or classes to identify it uniquely
            const allThankYouMessages = document.querySelectorAll('#notify_thank_you, #thank_you, #preorder_thank_you');
            console.log('All thank you messages in document:', allThankYouMessages.length);
            // Find the one that's closest to our popup
            for (let msg of allThankYouMessages) {
              const msgPopup = msg.closest('.notify_popup_container');
              if (msgPopup === popup) {
                thankYouMessage = msg;
                console.log('Found thank you message by proximity to popup');
                break;
              }
            }
          }
          
          const formState = popup.querySelector('.notify-popup-scroller');
          const closePopupButton = popup.querySelector('.notify_close_popup');
          
          console.log('Thank you message found:', !!thankYouMessage, 'Popup:', popup);
          if (thankYouMessage) {
            console.log('Thank you message element:', thankYouMessage, 'ID:', thankYouMessage.id, 'Current display:', window.getComputedStyle(thankYouMessage).display);
          } else {
            console.error('❌ Thank you message not found in popup');
            console.log('Popup:', popup);
            console.log('Popup classes:', popup?.className);
            console.log('Popup HTML (first 1000 chars):', popup?.innerHTML?.substring(0, 1000));
            
            // Check if notify-container exists
            const notifyContainer = popup?.querySelector('.notify-container');
            console.log('Notify container found:', !!notifyContainer);
            if (notifyContainer) {
              console.log('Notify container HTML:', notifyContainer.innerHTML.substring(0, 500));
              console.log('Elements in notify-container:', Array.from(notifyContainer.children).map(el => ({tag: el.tagName, id: el.id, class: el.className})));
            }
            
            // Check all elements with thank in ID or class
            const allThankElements = popup?.querySelectorAll('[id*="thank"], [id*="Thank"], .thank-you-message, [class*="thank"]');
            console.log('All thank-related elements in popup:', Array.from(allThankElements || []).map(el => ({
              tag: el.tagName,
              id: el.id, 
              class: el.className,
              display: window.getComputedStyle(el).display
            })));
            
            // Check if there are multiple popups
            const allPopups = document.querySelectorAll('.notify_popup_container');
            console.log('Total popups in document:', allPopups.length);
          }
          
          if (thankYouMessage) {
            // Update message text to "You will get notified soon" (only for notify me, not preorder)
            if (!isPreorder) {
              const messageText = thankYouMessage.querySelector('.thank-you-text, .product-msg, .pdp-custom-value-lable');
              if (messageText && !messageText.textContent.includes('preorder')) {
                messageText.textContent = 'You will get notified soon';
              }
            }
            
            // Show thank you message - use block for the container, important to override inline styles
            thankYouMessage.style.setProperty('display', 'block', 'important');
            thankYouMessage.style.visibility = 'visible';
            thankYouMessage.style.opacity = '1';
            
            // Ensure the inner thank-you-message uses flex
            const innerMessage = thankYouMessage.querySelector('.thank-you-message');
            if (innerMessage) {
              innerMessage.style.setProperty('display', 'flex', 'important');
            }
            
            // Ensure the notify-container is visible and properly displayed
            const notifyContainer = thankYouMessage.closest('.notify-container');
            if (notifyContainer) {
              notifyContainer.style.display = 'block';
            }
            
            console.log('Thank you message displayed, computed style:', window.getComputedStyle(thankYouMessage).display);
            console.log('Thank you message parent:', thankYouMessage.parentElement);
            
            // Hide form and close button
            if (formState) {
              formState.style.display = 'none';
            }
            if (closePopupButton) {
              closePopupButton.style.display = 'none';
            }
            
            // // Auto-close after 5 seconds
            const autoCloseTimer = setTimeout(() => {
              closeNotifyPopup(popup);
            }, 5000);
            
            // Store timer on popup so we can clear it if user closes manually
            popup.dataset.autoCloseTimer = autoCloseTimer;
          } else { 
            console.error('❌ Thank you message not found in popup');
            console.log('Available elements in popup:', popup.querySelectorAll('[id*="thank"], [id*="Thank"]'));
          }
        }
      })
      .catch(error => {
        console.error('Error submitting form:', error);
        alert('There was an error submitting your request. Please try again.'); 
      })
      .finally(() => {
        setTimeout(() => {
          isSubmitting = false;
          sendButton.disabled = false;
          sendButton.classList.remove('btn--loading');
        }, 1000);
      });   
    }
  });
  
  function validateNotifyForm(form) {
    const previousErrors = form.querySelectorAll('.error-message');
    previousErrors.forEach(error => error.remove());
    const checkbox = form.querySelector('#notify_me_checkbox');
    if (!checkbox || !checkbox.checked) {
      return false;
    } 
    const email = form.querySelector('[name="contact[email]"]');
    if (!email) {
      console.error('Required form fields not found');
      return false;
    }
    
    let isValid = true;
    
    if (email.value.trim() === '') {
      showError(email, 'Email is required');
      isValid = false;
    } else {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email.value.trim())) {
        showError(email, 'Please enter a valid email address');
        isValid = false;
      }
    }
    
    return isValid;
  }
  
  function showError(field, message) {
    field.classList.add('invalid');
    const fieldContainer = field.closest('.field');
    if (!fieldContainer) return;
    
    const existingError = fieldContainer.querySelector('.error-message');
    if (existingError) {
      existingError.textContent = message;
      return;
    }
    
    const errorElement = document.createElement('div');
    errorElement.className = 'error-message';
    errorElement.style.color = 'red';
    errorElement.style.fontSize = '12px';
    errorElement.style.marginTop = '4px';
    errorElement.textContent = message;
    fieldContainer.appendChild(errorElement);
  }
});
document.addEventListener('DOMContentLoaded', function() {
  let sizeVariantWrapper = document.querySelector('.size-variant-wrapper');
  let sizeVariant = document.querySelector('.size-variant');

  console.log('Initial Size variant wrapper:', sizeVariantWrapper);
  console.log('Initial Size variant:', sizeVariant);

  // Create wrapper and variant elements if they don't exist
  if (!sizeVariantWrapper) {
    sizeVariantWrapper = document.createElement('div');
    sizeVariantWrapper.className = 'size-variant-wrapper';
    document.body.appendChild(sizeVariantWrapper);
    console.log('Created size-variant-wrapper');
  }

  if (!sizeVariant) {
    sizeVariant = document.createElement('div');
    sizeVariant.className = 'size-variant';
    sizeVariantWrapper.appendChild(sizeVariant); 
    console.log('Created size-variant');
  }

  // Helper function to get fresh reference to size variant
  function getSizeVariant() {
    const wrapper = document.querySelector('.size-variant-wrapper');
    let variant = wrapper ? wrapper.querySelector('.size-variant') : null;
    
    if (!variant && wrapper) {
      variant = document.createElement('div');
      variant.className = 'size-variant';
      wrapper.appendChild(variant);
      console.log('Re-created size-variant');
    }
    
    return variant;
  }

  // ✅ USE EVENT DELEGATION - Listen on document instead of individual elements
  document.addEventListener('click', async function(e) {
    // Check if clicked element or its parent is a trigger
    const trigger = e.target.closest('.size-icon, .select-btn');
    
    if (!trigger) return; // Not a trigger, ignore

    e.preventDefault();
    e.stopPropagation();

    console.log('Trigger clicked!');

    // Find product info
    let productItem = trigger.closest('.grid-product');
    if (!productItem) {
      productItem = trigger.closest('[data-product-handle]'); 
    }
    
    if (!productItem) {
      console.warn('⚠️ No product item found for trigger');
      return;
    }

    let productHandle = productItem.getAttribute('data-product-handle');
    let productId = productItem.getAttribute('data-product-id');

    console.log('Product Handle:', productHandle);
    console.log('Product ID:', productId);

    if (!productHandle) {
      console.warn('⚠️ No product handle found');
      return;
    }

    // Get fresh references
    const wrapper = document.querySelector('.size-variant-wrapper');
    const variant = getSizeVariant();
    
    if (!wrapper || !variant) {
      console.error('❌ Size variant elements not found!');
      return;
    }

    wrapper.classList.add('active');
    console.log('Added active class to wrapper');

    try {
      const response = await fetch(`/products/${productHandle}.js`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const product = await response.json();

      console.log('Fetched product:', product);

      // Store product info in wrapper for later use
      wrapper.dataset.productHandle = productHandle;
      wrapper.dataset.productId = productId;
      wrapper.dataset.productTitle = product.title;

      let sizeOptionIndex = -1;

      // Find the size option
      if (Array.isArray(product.options)) {
        product.options.forEach((opt, index) => {
          const optName = (opt.name || opt || '').toString().toLowerCase();
          if (optName.includes('size')) {
            sizeOptionIndex = index;
            console.log("sizeOptionIndex:", sizeOptionIndex);
          }
        });
      }

      if (sizeOptionIndex === -1) {
        variant.innerHTML = `<div class="no-sizes">No "Size" option found for this product.</div>`; 
        addCloseButton(variant);
        return;
      }

      // Build list of size variants with full variant data
      let sizesArray = product.variants.map(v => ({
        size: v.options[sizeOptionIndex],
        available: v.available,
        id: v.id,
        sku: v.sku || '',
        title: v.title || v.options[sizeOptionIndex]
      }));

      console.log('Sizes array before dedup:', sizesArray);

      // Remove duplicates (keep first occurrence)
      const seenSizes = new Set();
      sizesArray = sizesArray.filter(v => {
        if (seenSizes.has(v.size)) {
          return false;
        }
        seenSizes.add(v.size);
        return true;
      });

      console.log('Sizes array after dedup:', sizesArray);

      // Generate product images HTML
      let imagesHTML = '';
      if (product.images && product.images.length > 0) {
        const imagesToShow = product.images // Show first 2 images
        imagesHTML = `
          <div class="size-popup-images">
            ${imagesToShow.map(img => `
              <img src="${img}" alt="${product.title}" class="size-popup-image">
            `).join('')}
          </div>
        `;
      }

      // Generate HTML
      const htmlContent = `
        <div class="size-popup-product-title">${product.title}</div>

        ${imagesHTML}
        <div class="size-header-row">
          <div class="size-header">SELECT SIZE</div>
        </div>
        <div class="size-options-grid">
          ${sizesArray
            .map(
              s => `
              <label class="size-label ${!s.available ? 'out-of-stock' : ''}" 
                     data-variant-id="${s.id}" 
                     data-variant-available="${s.available}"
                     data-variant-sku="${s.sku}"
                     data-variant-title="${s.title}">
                <input type="radio" 
                       name="size-${productId}" 
                       value="${s.size}" 
                       ${!s.available ? 'disabled' : ''}>
                <span class="size-value">${s.size}</span>
                ${!s.available ? '<span class="size-crossed"></span>' : ''}
              </label>
            `
            )
            .join('')}
        </div>
        <a href="/products/${productHandle}" class="view-product-link">
          VIEW COMPLETE PRODUCT PAGE
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      `;

      variant.innerHTML = htmlContent;
      console.log('Set innerHTML, variant element:', variant);
      console.log('Variant HTML:', variant.innerHTML);

      // Add close button
      addCloseButton(variant);

    } catch (err) {
      console.error('❌ Error fetching product:', err);
      const variant = getSizeVariant();
      if (variant) {
        variant.innerHTML = `<div class="error">Error loading product: ${err.message}</div>`;
        addCloseButton(variant);
      }
    }
  });

  // ✅ USE EVENT DELEGATION for size label clicks
  let lastClickTime = 0;

  document.addEventListener('click', function(e) {
    const label = e.target.closest('.size-label');
    
    if (!label || !label.closest('.size-variant')) return; // Not a size label in our popup

    const now = Date.now();
    if (now - lastClickTime < 800) return; // prevent double adds
    lastClickTime = now;

    // Handle out-of-stock variants - open notify popup
    if (label.classList.contains('out-of-stock')) {
      const variantId = label.dataset.variantId;
      if (!variantId) return;

      console.log('Out of stock variant clicked, opening notify popup');
      
      // Get product details from the wrapper
      const sizeVariantWrapper = label.closest('.size-variant-wrapper');
      const productHandle = sizeVariantWrapper?.dataset.productHandle;
      const productId = sizeVariantWrapper?.dataset.productId;
      const productTitle = sizeVariantWrapper?.dataset.productTitle;
      const variantTitle = label.dataset.variantTitle || label.querySelector('.size-value')?.textContent || '';
      const variantSku = label.dataset.variantSku || '';
      
      console.log('Notify popup data:', { productId, variantId, productTitle, variantTitle, variantSku });
      
      // Find all notify buttons and trigger the one with matching variant ID
      const notifyButtons = document.querySelectorAll('.notify-button, .notify_desktop-pdp-button');
      let notifyButton = null;
      
      // Try to find the specific notify button for this variant
      notifyButtons.forEach(btn => {
        if (btn.getAttribute('data-variant-id') === variantId) {
          notifyButton = btn;
        }
      });
      
      // If no specific button found, use the first one and update its data
      if (!notifyButton && notifyButtons.length > 0) {
        notifyButton = notifyButtons[0];
      }
      
      if (notifyButton) {
        // Update button attributes with current variant data
        notifyButton.setAttribute('data-product-id', productId || '');
        notifyButton.setAttribute('data-variant-id', variantId);
        notifyButton.setAttribute('data-product-title', productTitle || '');
        notifyButton.setAttribute('data-variant-title', variantTitle);
        notifyButton.setAttribute('data-variant-sku', variantSku);
        
        console.log('Updated notify button attributes:', {
          productId,
          variantId,
          productTitle,
          variantTitle,
          variantSku
        });
        
        // Trigger click on the notify button
        notifyButton.click();
      } else {
        console.error('No notify button found on page');
      }
      
      // Close the size variant popup
      const wrapper = document.querySelector('.size-variant-wrapper');
      if (wrapper) wrapper.classList.remove('active');
      
      return;
    }

    const variantId = label.dataset.variantId;
    if (!variantId) return;

    // Highlight selected
    const variant = label.closest('.size-variant');
    variant.querySelectorAll('.size-label').forEach(l => l.classList.remove('selected'));
    label.classList.add('selected');

    console.log('🛒 Adding variant to cart:', variantId);

    // Try global cartUtils first, fallback to direct method
    if (window.cartUtils && typeof window.cartUtils.addToCart === 'function') {
      window.cartUtils.addToCart(variantId, 1);
    } else {
      addToCartDirect(variantId, 1);
    }

    // Auto-close
    const wrapper = document.querySelector('.size-variant-wrapper');
    setTimeout(() => {
      if (wrapper) wrapper.classList.remove('active');
    }, 300);
  });

  // Helper function to add close button
  function addCloseButton(variantElement) {
    if (!variantElement) {
      console.error('Cannot add close button - variant element is null');
      return;
    }

    const existingClose = variantElement.querySelector('.size-variant-close');
    if (existingClose) {
      existingClose.remove();
    }
    
    const closeBtn = document.createElement('button');
    closeBtn.className = 'size-variant-close';
    closeBtn.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg>';
    closeBtn.addEventListener('click', () => {
      const wrapper = document.querySelector('.size-variant-wrapper');
      if (wrapper) wrapper.classList.remove('active');
    });
    variantElement.prepend(closeBtn);
    console.log('Close button added');
  }

  // Fallback add-to-cart method
  function addToCartDirect(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => {
        console.log('🛒 Cart updated:', cart);

        // Update cart count using cartUtils if available
        if (window.cartUtils && window.cartUtils.updateCartCount) {
          window.cartUtils.updateCartCount(cart.item_count);
        } else {
          // Fallback: update cart count manually
          document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
          // Update header cart bubble
          const cartBubble = document.querySelector('.cart-link__bubble');
          if (cartBubble) {
            if (cart.item_count > 0) {
              cartBubble.textContent = cart.item_count;
              cartBubble.classList.add('cart-link__bubble--visible');
            } else {
              cartBubble.textContent = '';
              cartBubble.classList.remove('cart-link__bubble--visible');
            }
          }
          // Update mobile footer badge
          const mobileBadge = document.querySelector('.mobile-bottom-nav__badge');
          const mobileCartWrapper = document.querySelector('.mobile-bottom-nav__cart-wrapper');
          if (mobileCartWrapper) {
            if (cart.item_count > 0) {
              if (mobileBadge) {
                mobileBadge.textContent = cart.item_count;
              } else {
                const newBadge = document.createElement('span');
                newBadge.className = 'mobile-bottom-nav__badge';
                newBadge.textContent = cart.item_count;
                mobileCartWrapper.appendChild(newBadge);
              }
            } else {
              if (mobileBadge) {
                mobileBadge.remove();
              }
            }
          }
        }

        // Show mobile toast if it exists
        const toast = document.getElementById('mobile-cart-toast');
        if (toast) {
          toast.classList.add('show');
          setTimeout(() => toast.classList.remove('show'), 4000);
        }

        // Trigger custom event for other scripts to listen to
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(err => {
        console.error('❌ Error adding to cart:', err);
        alert('Error adding product to cart. Please try again.');
      });
  }

  // Close popup when clicking outside
  document.addEventListener('click', function(e) {
    const wrapper = document.querySelector('.size-variant-wrapper');
    if (wrapper && e.target === wrapper) {
      wrapper.classList.remove('active');
    }
  });

  // Close with Escape key
  document.addEventListener('keydown', e => {
    const wrapper = document.querySelector('.size-variant-wrapper');
    if (e.key === 'Escape' && wrapper && wrapper.classList.contains('active')) {
      wrapper.classList.remove('active');
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {

	let cartBtnWrap = document.querySelector('.product-single__form');
if (cartBtnWrap) {
	console.log("cartBtnWrap", cartBtnWrap)

	let cartBtn = cartBtnWrap.querySelector('[data-add-to-cart]');
	let stickyCartBtn = document.querySelector('.sticky-atc [data-add-to-cart]'); // Add sticky cart button  
	console.log("cartBtn", cartBtn);
	console.log("stickyCartBtn", stickyCartBtn);

	let buyBtn = cartBtnWrap.querySelector('#gokwik-buy-now[data-buy-cart]');
	let variantCheck = document.querySelectorAll('.product-single__meta .variant_check_length input[type="radio"]');
	let lengthVar = document.querySelectorAll('.variant-selectors .variant-wrapper.variant_check_length');

	// Store current variant ID
	let currentVariantId = null;

	function isVariantSelected() {
		let selectedVariants = Array.from(variantCheck).filter(variant => variant.checked);
		return selectedVariants.length === lengthVar.length;
	}

	// Get selected variant ID - enhanced version
	function getSelectedVariantId() {
		console.log('=== Getting Variant ID ===');
		
		// Method 1: Try to get from form select/input
		const variantIdInput = document.querySelector('select[name="id"], input[name="id"]');
		if (variantIdInput && variantIdInput.value) {
			console.log('✓ Variant ID from form input:', variantIdInput.value);
			return variantIdInput.value;
		}

		// Method 2: Get from checked radio button's data attribute
		const checkedInput = document.querySelector('[data-variant-input]:checked');
		if (checkedInput && checkedInput.dataset.variantId) {
			console.log('✓ Variant ID from radio data-variant-id:', checkedInput.dataset.variantId);
			return checkedInput.dataset.variantId;
		}

		// Method 3: Get product JSON and match all selected options
		const productJson = document.querySelector('[data-product-json]');
		if (!productJson) {
			console.error('✗ No product JSON found - add it to your template');
			return null;
		}

		try {
			const product = JSON.parse(productJson.textContent);
			console.log('Product loaded:', product.title);
			
			// Get all selected option values
			const selectedOptions = [];
			const allCheckedInputs = document.querySelectorAll('[data-variant-input]:checked');
			
			console.log('Checked inputs found:', allCheckedInputs.length);
			
			allCheckedInputs.forEach((input, index) => {
				const optionValue = input.value;
				selectedOptions.push(optionValue);
				console.log(`Option ${index + 1}:`, optionValue);
			});

			if (selectedOptions.length === 0) {
				console.warn('✗ No options selected');
				return null;
			}

			// Find matching variant
			const matchingVariant = product.variants.find(variant => {
				// Build an array of this variant's option values
				const variantOptions = [
					variant.option1,
					variant.option2,
					variant.option3
				].filter(opt => opt !== null);

				// Check if all selected options match this variant
				const matches = selectedOptions.every(selectedValue => 
					variantOptions.includes(selectedValue)
				);

				if (matches) {
					console.log('✓ Found matching variant:', variant.title, 'ID:', variant.id);
				}

				return matches;
			});

			if (matchingVariant) {
				currentVariantId = matchingVariant.id;
				return matchingVariant.id;
			}

			console.error('✗ No matching variant found for options:', selectedOptions);
			return null;
		} catch (e) {
			console.error('✗ Error parsing product JSON:', e);
			return null;
		}
	}

	// Update variant ID when options change
	function updateCurrentVariant(variantId) {
		// If no variantId passed, get it
		if (!variantId) {
			variantId = getSelectedVariantId();
		}
		
		if (variantId) {
			currentVariantId = variantId;
			console.log('✓ Current variant updated to:', currentVariantId);
			
			// Update hidden input if it exists
			const hiddenInput = document.querySelector('input[name="id"]');
			if (hiddenInput) {
				hiddenInput.value = variantId;
			}
			
			// Update select if it exists
			const selectInput = document.querySelector('select[name="id"]');
			if (selectInput) {
				selectInput.value = variantId;
			}
		}
	}

	document.querySelectorAll('[data-variant-input]').forEach(input => {
		input.addEventListener('change', function(e) {
			let variantId = e.target.getAttribute("data-variant-id");
			setTimeout(() => {
				updateCurrentVariant(variantId);
			}, 100); // Small delay to ensure DOM is updated
		});
	});

	setTimeout(() => {
		updateCurrentVariant();
	}, 500);

	// document.addEventListener('variant:change', function(e) {
	// 	console.log('variant:change event fired');
	// 	if (e.detail && e.detail.variant && e.detail.variant.id) {
	// 		currentVariantId = e.detail.variant.id;
	// 		console.log('✓ Variant updated via event:', currentVariantId);
	// 	}
	// });

	function handleAddToCart(event, source) {
    console.log("handleAddToCart")
		event.preventDefault(); // Always prevent default
		
		if (!isVariantSelected()) {
			document.querySelector('.variant-selectors').scrollIntoView({
				behavior: 'smooth'
			});
			document.querySelector('.err_mes_size').innerHTML = 'Please select a size option';
			document.querySelector('.err_mes_size').closest('.variant_check_length').querySelector('.variant-input-wrap').classList.add('error_active');
		}
		else {
			// Clear error messages
      if(addToCartButton){
      addToCartButton.disabled = true;
      addToCartButton.classList.add('btn--loading');
      }
			document.querySelector('.err_mes_size').innerHTML = '';
			document.querySelector('.err_mes_size').closest('.variant_check_length').querySelector('.variant-input-wrap').classList.remove('error_active');
			
			// Get the latest variant ID
			const qtyInput = document.querySelector('.js-qty__num');
			console.log("qtyInput", qtyInput);
			const qnt = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
			
			const variantId = getSelectedVariantId() || currentVariantId;
			console.log('Final variant ID for cart:', variantId);
			
			if (variantId && window.cartUtils && typeof window.cartUtils.addToCart === 'function') {
				console.log('✓ Using cartUtils.addToCart');
				window.cartUtils.addToCart(variantId, qnt);
			} else if (variantId) {
				// Fallback: manual add to cart with notification
				console.log('⚠ Using fallback add to cart method');
				fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ id: variantId, quantity: qnt })
				})
				.then(res => res.json())
				.then(() => fetch('/cart.js'))
				.then(res => res.json())
				.then(cart => {
					console.log('✓ Cart updated successfully');
          
					const addedItem = cart.items.find(item => item.variant_id == variantId);
					if (window.cartUtils && window.cartUtils.showCartNotification) {
						window.cartUtils.showCartNotification(addedItem, cart);
					}  
					if (window.cartUtils && window.cartUtils.updateCartCount) {
						window.cartUtils.updateCartCount(cart.item_count);
					} else {
						// Fallback: update cart count manually
						document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
							el.textContent = cart.item_count;
						});
						// Update header cart bubble
						const cartBubble = document.querySelector('.cart-link__bubble');
						if (cartBubble) {
							if (cart.item_count > 0) {
								cartBubble.textContent = cart.item_count;
								cartBubble.classList.add('cart-link__bubble--visible');
							} else {
								cartBubble.textContent = '';
								cartBubble.classList.remove('cart-link__bubble--visible');
							}
						}
						// Update mobile footer badge
						const mobileBadge = document.querySelector('.mobile-bottom-nav__badge');
						const mobileCartWrapper = document.querySelector('.mobile-bottom-nav__cart-wrapper');
						if (mobileCartWrapper) {
							if (cart.item_count > 0) {
								if (mobileBadge) {
									mobileBadge.textContent = cart.item_count;
								} else {
									const newBadge = document.createElement('span');
									newBadge.className = 'mobile-bottom-nav__badge';
									newBadge.textContent = cart.item_count;
									mobileCartWrapper.appendChild(newBadge);
								}
							} else {
								if (mobileBadge) {
									mobileBadge.remove();
								}
							}
						}
					}
				})
				.catch(err => {
					console.error('✗ Error adding to cart:', err);
					alert('Error adding to cart. Please try again.');
				});
			} else {
				console.error('✗ Could not determine variant ID');
				alert('Please select all required options');
			}  
		}
	}

	// Add event listener to regular cart button
	if (cartBtn) {
		cartBtn.addEventListener('click', (event) => handleAddToCart(event, 'Regular'));
	}

	// Add event listener to sticky cart button
// Add event listener to sticky cart button
if (stickyCartBtn) {  
	stickyCartBtn.addEventListener('click', (event) => handleAddToCart(event, 'Sticky'));
}

document.addEventListener('variant:change', function(e) {
	if (e.detail && e.detail.variant && e.detail.variant.id) {
		currentVariantId = e.detail.variant.id;
		// Get the variant object
		const variant = e.detail.variant;
		
		// Get sticky cart buttons
		const stickyCart = document.querySelector('.floating-cart');
		if (stickyCart) {
			const buyNowBtn = stickyCart.querySelector('.buy-now');
			const addToCartBtn = stickyCart.querySelector('.add-to-cart');
			const notifyContainer = stickyCart.querySelector('.payment_custom_btn');
			const notifyButton = stickyCart.querySelector('.notify-button');
      console.log("addToCartBtn: ", addToCartBtn);
			console.log("notifyButton: ", notifyButton);

			// Update data-curr-id attributes
			if (buyNowBtn) buyNowBtn.setAttribute('data-curr-id', variant.id);
			if (addToCartBtn) addToCartBtn.setAttribute('data-curr-id', variant.id);
			
			// Update notify button data attributes
			if (notifyButton) {
				notifyButton.setAttribute('data-variant-id', variant.id);
				notifyButton.setAttribute('data-variant-title', variant.title || '');
			}
      console.log("new on load variantId: ", variant);
			if (variant.available) {
				// Variant is available - show Add to Cart and Buy Now buttons
				if (buyNowBtn) {
					buyNowBtn.disabled = false;
					buyNowBtn.style.display = '';
				}
				if (addToCartBtn) {
					addToCartBtn.disabled = false;
					// Show "ADD TO CART" text
					addToCartBtn.innerHTML = 'ADD TO CART';
          addToCartBtn.style.display = 'block';
				}
        if (notifyButton) {
          notifyButton.style.display = 'none';
        }
				// Hide notify me container
				if (notifyContainer) {
					notifyContainer.style.display = 'none';
				}        
			} else {
				// Variant is NOT available - show Notify Me button
        console.log("in else part");
				if (buyNowBtn) {
					buyNowBtn.disabled = true;
					buyNowBtn.style.display = 'none';
				}
				if (addToCartBtn) {
					addToCartBtn.disabled = true;
					// Replace button content with notify me structure
          addToCartBtn.style.display = 'none';
					addToCartBtn.innerHTML = notifyContainer ? notifyContainer.outerHTML : '';
				}

        if (notifyButton) {
          notifyButton.style.display = 'block';
        }
				// Show notify me container
				if (notifyContainer) {
					notifyContainer.style.display = 'block';
				}
			}
			
			// Add click handler for notify button if it doesn't exist
			const notifyBtn = stickyCart.querySelector('.notify-button');
			if (notifyBtn && !notifyBtn.hasAttribute('data-listener-added')) {
				notifyBtn.setAttribute('data-listener-added', 'true');
				notifyBtn.addEventListener('click', function(e) {
					e.preventDefault();
					const popup = stickyCart.querySelector('.notify_popup_container');
					if (popup) {
						popup.style.display = 'block';
						// Add close functionality
						const closeBtn = popup.querySelector('.notify_close_popup');
						const closeBtnBottom = popup.querySelector('.notify_close_btn');
						
						if (closeBtn) {
							closeBtn.addEventListener('click', () => {
								popup.style.display = 'none';
							});
						}
						if (closeBtnBottom) {
							closeBtnBottom.addEventListener('click', () => {
								popup.style.display = 'none';
							});
						}
					}
				});
			}
		}
		
		// Handle main product form notify button
		const mainProductForm = document.querySelector('.product-single__form');
		if (mainProductForm) {
			const mainNotifyContainer = mainProductForm.querySelector('.payment_custom_btn');
			const mainNotifyButton = mainProductForm.querySelector('.notify-button');
			const mainNotifyLink = mainProductForm.querySelector('.notify_desktop-pdp-button');
			const mainAddToCartBtn = mainProductForm.querySelector('[data-add-to-cart]');
      console.log("mainAddToCartBtn: ", mainAddToCartBtn);
			
			// Update notify button data attributes
			if (mainNotifyButton) {
				mainNotifyButton.setAttribute('data-variant-id', variant.id);
				mainNotifyButton.setAttribute('data-variant-title', variant.title || '');
				if (variant.sku) {
					mainNotifyButton.setAttribute('data-variant-sku', variant.sku);
				}
			}
			
			if (mainNotifyLink) {
				mainNotifyLink.setAttribute('data-variant-id', variant.id);
				mainNotifyLink.setAttribute('data-variant-title', variant.title || '');
				if (variant.sku) {
					mainNotifyLink.setAttribute('data-variant-sku', variant.sku);
				}
			}
			
			if (variant.available) {
				// Variant is available - hide notify button, show add to cart
				if (mainNotifyContainer) {
					mainNotifyContainer.style.display = 'none';
				}
				if (mainAddToCartBtn) {
					mainAddToCartBtn.disabled = false;
					mainAddToCartBtn.style.display = '';
				}
			} else {
				// Variant is NOT available - show notify button, hide add to cart
				if (mainNotifyContainer) {
					mainNotifyContainer.style.display = 'block';
				}
				if (mainAddToCartBtn) {
					mainAddToCartBtn.disabled = true;
					mainAddToCartBtn.style.display = 'none';
				}
			}
		}
	}
});

// Initialize button visibility on page load
document.addEventListener('DOMContentLoaded', function() {
	function initializeButtonVisibility() {
		const mainProductForm = document.querySelector('.product-single__form');
		if (!mainProductForm) return;
		
		const mainNotifyContainer = mainProductForm.querySelector('.payment_custom_btn');
		const mainAddToCartBtn = mainProductForm.querySelector('[data-add-to-cart]');
		
		// Check if add to cart button is disabled (indicates variant is not available)
		const isVariantAvailable = mainAddToCartBtn && !mainAddToCartBtn.disabled;
		
		// Also check variant select as fallback
		const variantSelect = mainProductForm.querySelector('select[name="id"]');
		let isAvailable = isVariantAvailable;
		
		if (variantSelect && variantSelect.value) {
			const selectedOption = variantSelect.querySelector(`option[value="${variantSelect.value}"]`);
			if (selectedOption) {
				isAvailable = !selectedOption.disabled;
			}
		}
		
		if (isAvailable) {
			// Variant is available - hide notify button, show add to cart
			if (mainNotifyContainer) {
				mainNotifyContainer.style.display = 'none';
			}
			if (mainAddToCartBtn) {
				mainAddToCartBtn.disabled = false;
				mainAddToCartBtn.style.display = '';
			}
		} else {
			// Variant is NOT available - show notify button, hide add to cart
			if (mainNotifyContainer) {
				mainNotifyContainer.style.display = 'block';
			}
			if (mainAddToCartBtn) {
				mainAddToCartBtn.disabled = true;
				mainAddToCartBtn.style.display = 'none';
			}
		}
	}
	
	// Run on DOMContentLoaded
	initializeButtonVisibility();
	
	// Also run after a short delay to ensure variant select is initialized
	setTimeout(initializeButtonVisibility, 100);
	
	// Run when variant select changes
	const variantSelect = document.querySelector('.product-single__form select[name="id"]');
	if (variantSelect) {
		variantSelect.addEventListener('change', initializeButtonVisibility);
	}
});

	buyBtn?.addEventListener('click', (event) => {
		if (!isVariantSelected()) {
			event.preventDefault();
			document.querySelector('.variant-selectors').scrollIntoView({
				behavior: 'smooth'
			});
			document.querySelector('.err_mes_size').innerHTML = 'Please select a size option';
			document.querySelector('.err_mes_size').closest('.variant_check_length').querySelector('.variant-input-wrap').classList.add('error_active');
		}
		else {
			document.querySelector('.err_mes_size').innerHTML = '';
			document.querySelector('.err_mes_size').closest('.variant_check_length').querySelector('.variant-input-wrap').classList.remove('error_active');
			onBuyNowClick(buyBtn);
		}
	});
}
	const buyClose = document.querySelector('.shopify-payment-button .error_inSize');
	let getVariant = localStorage.getItem("prd_grid_variant");
	if(buyClose){
		buyClose.addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('.err_mes_size').innerHTML = 'Please select a size option';
			document.querySelector('.err_mes_size').closest('.variant_check_length').querySelector('.variant-input-wrap').classList.add('error_active');
		})
	var flobuy_check  = document.querySelector('#gokwik-buy-now');
	console.log('click');
	if (!isVariantSelected()) {
		if (window.getComputedStyle(flobuy_check).display === "block") {
			flobuy_check.style.display = "none";
			buyClose.style.display = "block";
		}
	}
	else{
		if (window.getComputedStyle(flobuy_check).display === "none") {
			flobuy_check.style.display = "block";
			buyClose.style.display = "none";
		}
	}
	}
	

	// if user arrives from grid item then select a variant:::
	if (getVariant) {
		let variantObj = JSON.parse(getVariant);
		let productId = variantObj.product_id;
		let productVar = variantObj.selected_var;
		let currentPrd = document.querySelectorAll('.variant-selectors .variant-wrapper .variant-input');
		if (currentPrd) {
			currentPrd.forEach((productVariant) => {
				let curr_prd_id = productVariant.closest('.product-section').dataset.productId;
				let variants = productVariant.getAttribute('data-value');
				if (curr_prd_id == productId && variants == productVar) {
						// click variant selected from Grid Item...
						productVariant.click();
						productVariant.querySelector('input[type="radio"]').click();
						// change size in drop-down...
						let sizeDrpDwn = document.querySelector('floating-cart .size_name');
						sizeDrpDwn.textContent = productVar;
						var flobuy_now_grid  = document.querySelector('#flo-buy-now-button');
						var error_now_grid = document.querySelector('.error_inSize');
						if (window.getComputedStyle(flobuy_now_grid).display === "none") {
							flobuy_now_grid.style.display = "block";
							error_now_grid.style.display = "none";
						}
					}
			})
		}
	}

	// document.addEventListener("variant:change", (e) => {
	// 	var flobuy_now  = document.querySelector('#flo-buy-now-button');
	// 	var error_now = document.querySelector('.error_inSize');
	// 	// if (window?.getComputedStyle(flobuy_now)?.display === "none") {
	// 	// 	flobuy_now.style.display = "block";
	// 	// 	error_now.style.display = "none";
	// 	// }
	// });
  // Function to initialize swatch visibility
function initializeSwatchVisibility() {
  setTimeout(()=>
  {
  document.querySelectorAll('.product-variant-swatches').forEach((swatchContainer) => {
    // Skip if already initialized
    if (swatchContainer.dataset.swatchesInitialized === 'true') return;
    
    const swatches = swatchContainer.querySelectorAll('.variant-swatch');
    const maxVisible = 3;

    if (swatches.length > maxVisible) {
      // Hide extra swatches
      swatches.forEach((swatch, index) => {
        if (index >= maxVisible) {
          swatch.style.display = 'none';
          swatch.dataset.hidden = 'true'; // ✅ Mark as hidden
        } else {
          swatch.style.display = 'inline-block';
          swatch.dataset.hidden = 'false'; // ✅ Mark as visible
        }
      });

      // Create toggle button
      const hiddenCount = swatches.length - maxVisible;
      const toggleBtn = document.createElement('button');
      toggleBtn.className = 'variant-toggle-btn';
      toggleBtn.textContent = `+${hiddenCount}`;
      toggleBtn.type = 'button';

      swatchContainer.appendChild(toggleBtn);
      swatchContainer.dataset.swatchesInitialized = 'true';
      swatchContainer.dataset.maxVisible = maxVisible; // ✅ Store on container
    }
  });
    },1000)
}

// Event delegation for toggle button
document.addEventListener('click', function(e) {
  const toggleBtn = e.target.closest('.variant-toggle-btn');
  if (toggleBtn) {
    e.preventDefault();
    e.stopPropagation();
    
    const swatchContainer = toggleBtn.closest('.product-variant-swatches');
    // ✅ Re-query swatches from the container (fresh list)
    const swatches = swatchContainer.querySelectorAll('.variant-swatch');
    const maxVisible = parseInt(swatchContainer.dataset.maxVisible) || 3;
    
    const isExpanded = toggleBtn.classList.toggle('expanded');
    
    if (isExpanded) {
      // Show all swatches
      swatches.forEach((swatch) => {
        swatch.style.display = 'inline-block';
      });
      toggleBtn.textContent = '−';
    } else {
      // Hide extra swatches
      swatches.forEach((swatch, index) => {
        if (index >= maxVisible) {
          swatch.style.display = 'none';
        } else {
          swatch.style.display = 'inline-block';
        }
      });
      const hiddenCount = swatches.length - maxVisible;
      toggleBtn.textContent = `+${hiddenCount}`;
    }
  }
});

// Initialize on page load
initializeSwatchVisibility();

// Auto-detect AJAX updates
const observer = new MutationObserver(function(mutations) {
  let shouldReinit = false;
  
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Check if new product cards were added
          if (node.classList?.contains('grid-product') || 
              node.classList?.contains('product-item') ||
              node.querySelector?.('.product-variant-swatches')) {
            shouldReinit = true;
          }
        }
      });
    }
  });
  
  if (shouldReinit) {
    // Small delay to ensure DOM is fully updated
    setTimeout(initializeSwatchVisibility, 100);
  }
});

// Start observing (adjust selector to match your theme)
const productContainer = document.querySelector('.product-grid, .collection-grid, [data-collection-container], .grid--uniform, main');
if (productContainer) {
  observer.observe(productContainer, {
    childList: true,
    subtree: true
  });
}

// Expose globally
window.reinitSwatches = initializeSwatchVisibility;

    // Prevent accidental double-click adds
    let lastClickTime = 0;

    const variantSwatches = document.querySelectorAll('.variant-swatch');
	// setTimeout(()=>
	// {
		
// Remove the forEach loop and use delegation instead
document.addEventListener('click', function(e) {
  // Handle variant swatch clicks
  const swatch = e.target.closest('.variant-swatch');
  if (swatch) {
    e.preventDefault();
    e.stopPropagation();
    
    const isCurrent = swatch.dataset.isCurrent === 'true';
    const isDisabled = swatch.dataset.disabled === 'true';
    
    if (isCurrent || isDisabled) return;
    
    const targetHandle = swatch.dataset.productHandle;
    const targetUrl = swatch.dataset.productUrl;
    const productCard = swatch.closest('.grid-product');
    const swatchContainer = swatch.closest('.product-variant-swatches');
    
    // Update active state
    swatchContainer.querySelectorAll('.variant-swatch').forEach((s) => {
      s.classList.remove('active');
      s.dataset.isCurrent = 'false';
    });
    swatch.classList.add('active');
    swatch.dataset.isCurrent = 'true';
    
    // Fetch the variant product data
    fetch(`/products/${targetHandle}.js`)
      .then((response) => response.json())
      .then((productData) => {
        updateProductCard(productCard, productData, targetUrl);
      })
      .catch((error) => {
        console.error('Error fetching product data:', error);
      });
  }
  
  // Handle size label clicks
  const sizeLabel = e.target.closest('.size-label');
  if (sizeLabel) {
    const now = Date.now();
    if (now - lastClickTime < 800) return;
    lastClickTime = now;
    
    if (sizeLabel.classList.contains('out-of-stock')) return;
    
    const variantId = sizeLabel.dataset.variantId;
    if (!variantId) return;
    
    const sizeOptions = sizeLabel.closest('.size-options');
    sizeOptions?.querySelectorAll('.size-label').forEach((l) => l.classList.remove('selected'));
    sizeLabel.classList.add('selected');
    
    console.log('Adding variant to cart:', variantId);
    
    if (window.cartUtils && typeof window.cartUtils.addToCart === 'function') {
      window.cartUtils.addToCart(variantId, 1);
    } else {
      console.error('Cart utilities not loaded yet');
    }
  }
});

    function updateProductCard(card, productData, productUrl) {
      console.log("updateProductCard")
      // Update product link
      const productLink = card.querySelector('.grid__item-image-wrapper');
      if (productLink) {
        productLink.href = productUrl;
      }

      // Update Swiper with new images
      const swiperWrapper = card.querySelector('.swiper-wrapper');
      if (swiperWrapper && productData.media) {
        // Get existing image ratio class from current structure
        const existingImageRatio = card.querySelector('.grid__image-ratio');
        let imageRatioClasses = ['grid__image-ratio--portrait'];
        if (existingImageRatio) {
          const classes = Array.from(existingImageRatio.classList).filter(
            (cls) => cls !== 'grid__image-ratio'
          );
          if (classes.length) {
            imageRatioClasses = classes;
          }
        }
        const imageRatioClassName = ['grid__image-ratio', ...imageRatioClasses].join(' ');

        swiperWrapper.innerHTML = '';

        productData.media.forEach((media) => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';

          // Create grid__image-ratio wrapper
          const imageRatioDiv = document.createElement('div');
          imageRatioDiv.className = imageRatioClassName;

          // Create image-element wrapper
          const imageElement = document.createElement('image-element');
          imageElement.setAttribute('data-aos', 'image-fade-in');
          imageElement.setAttribute('data-aos-offset', '150');
          imageElement.className = 'aos-init aos-animate';

          // Create img element with proper attributes
          const img = document.createElement('img');
          
          // Build srcset from available media sizes
          const widths = [360, 540, 720, 900, 1080];
          const srcsetParts = widths.map(width => {
            // Use Shopify's image URL format with width parameter
            // Handle URLs that may already have query parameters
            let imageUrl = media.src || '';
            const separator = imageUrl.includes('?') ? '&' : '?';
            return `${imageUrl}${separator}width=${width} ${width}w`;
          });
          img.srcset = srcsetParts.join(', ');
          
          // Set src to the largest size (add width parameter if not present)
          let srcUrl = media.src || '';
          if (srcUrl && !srcUrl.includes('width=')) {
            const separator = srcUrl.includes('?') ? '&' : '?';
            srcUrl = `${srcUrl}${separator}width=1080`;
          }
          img.src = srcUrl;
          img.alt = productData.title || '';
          img.className = 'grid-product__image image-style-- image-element';
          img.loading = 'lazy';
          img.sizes = '(min-width: 769px) 25vw, 50vw';
          
          // Set width and height if available
          if (media.width) {
            img.width = media.width;
          } else {
            img.width = 1080; // default to largest size
          }
          if (media.height) {
            img.height = media.height;
          } else if (media.aspect_ratio) {
            img.height = Math.round(img.width / media.aspect_ratio);
          } else {
            // Default height calculation for portrait images (3:4 ratio)
            img.height = Math.round(img.width * 1.333);
          }

          // Assemble the structure
          imageElement.appendChild(img);
          imageRatioDiv.appendChild(imageElement);
          slide.appendChild(imageRatioDiv);
          swiperWrapper.appendChild(slide);
        });

        // Reinitialize Swiper if it exists
        const swiperContainer = card.querySelector('.grid-product-swiper');
        if (swiperContainer && swiperContainer.swiper) {
          swiperContainer.swiper.update();
          swiperContainer.swiper.slideTo(0);
        }
      }

      // Update product title
      const titleElement = card.querySelector('.grid-product__title');
      if (titleElement) {
        titleElement.textContent = productData.title;
      }

      // Update product price
      const priceElement = card.querySelector('.grid-product__price');
      if (priceElement && productData.variants && productData.variants.length > 0) {
        const variant = productData.variants[0];
        const price = formatMoney(variant.price);
        const comparePrice = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;

        if (comparePrice && variant.compare_at_price > variant.price) {
          priceElement.innerHTML = `
          <span class="grid-product__price--original">${comparePrice}</span>
          <span class="grid-product__price--sale">${price}</span>
        `;
        } else {
          priceElement.innerHTML = `<span>${price}</span>`;
        }
      }

      // Update size options if they exist
      updateSizeOptions(card, productData);

      // Update data attributes
      card.dataset.productHandle = productData.handle;
      card.dataset.productId = productData.id;

      // CRITICAL: Re-attach size option event listeners after DOM update
      attachSizeListeners(card);
    }

    function updateSizeOptions(card, productData) {
      const sizeContainer = card.querySelector('.size-options');
      if (!sizeContainer) return; 
      
      // Find SIZE option
      const sizeOption = productData.options.find((opt) => opt.name.toLowerCase() === 'size');
      console.log("updateSizeOptions", sizeOption);
      
      if (!sizeOption) return;
    
      sizeContainer.innerHTML = '';
      sizeContainer.dataset.productId = productData.id;
    
      // Add the size title
      const sizeTitle = document.createElement('div');
      sizeTitle.className = 'size-title';
      sizeTitle.textContent = 'SELECT SIZE';
      sizeContainer.appendChild(sizeTitle);
    
      // Check if this is a pre-order product based on tags
      const showPreorderSetting = document.body?.dataset?.showNotifyPreorder === 'true' || false;
      
      // Get product tags
      const productTags = productData.tags || [];
      console.log("🏷️ Product Tags (raw):", productTags);
      console.log("🏷️ Product Tags type:", typeof productTags);
      console.log("🏷️ Is Array?:", Array.isArray(productTags));
      
      // Convert tags to array if it's a string
      let tagsArray = [];
      if (Array.isArray(productTags)) {
        tagsArray = productTags.map(t => String(t).trim().toLowerCase());
      } else if (typeof productTags === 'string') {
        tagsArray = productTags.toLowerCase().split(',').map(t => t.trim());
      }
      
      console.log("🏷️ Tags Array (processed):", tagsArray);
      
      // Check for preorder tag (check multiple variations)
      const hasPreorderTag = tagsArray.some(tag => 
        tag === 'preorder' || 
        tag === 'pre-order' || 
        tag === 'pre order' ||
        tag.includes('preorder') ||
        tag.includes('pre-order')
      );
      
      console.log("🏷️ Has Preorder Tag?:", hasPreorderTag);
      console.log("🏷️ Show Preorder Setting?:", showPreorderSetting);
      
      const isPreorder = hasPreorderTag;
      
      console.log("✅ Final isPreorder Decision:", isPreorder);
    
      sizeOption.values.forEach((value) => {
        const variant = productData.variants.find(
          (v) => v.option1 === value || v.option2 === value || v.option3 === value
        );
    
        if (variant) {
          const label = document.createElement('label');
          label.className = `size-label ${!variant.available ? 'out-of-stock' : ''}`;
          label.dataset.variantId = variant.id;
          label.dataset.variantAvailable = variant.available;
    
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = `size-${productData.id}`;
          input.value = value;
          input.dataset.variantId = variant.id;
          if (!variant.available) input.disabled = true;
    
          label.appendChild(input);
    
          // Add notify/preorder button structure for out-of-stock items
          if (!variant.available) {
            const paymentCustomBtn = document.createElement('div');
            paymentCustomBtn.className = 'payment_custom_btn notify_fun_on';
            
            if (isPreorder) {
              console.log(`🎯 Creating PRE-ORDER button for variant ${variant.id}`);
              
              // Add "Available Soon!" text
              const availableSoonSpan = document.createElement('span');
              availableSoonSpan.textContent = 'Available Soon!';
              paymentCustomBtn.appendChild(availableSoonSpan);
                
              // PRE-ORDER BUTTON
              const pdpNotifyButton = document.createElement('div');
              pdpNotifyButton.className = 'pdp-notify-button button button--full-width main-p-form';
              pdpNotifyButton.style.display = 'block';
              
              const preorderLink = document.createElement('a');
              preorderLink.href = '#';
              preorderLink.className = 'preorder_desktop-pdp-button product-form__buttons preorder-btn btn btn--full';
              preorderLink.dataset.productId = productData.id;
              preorderLink.dataset.variantId = variant.id;
              preorderLink.dataset.productTitle = productData.title;
              preorderLink.dataset.variantTitle = variant.title;
              preorderLink.dataset.variantSku = variant.sku || '';
              preorderLink.dataset.preorderBtn = '';
              
              const buttonInner = document.createElement('div');
              buttonInner.className = 'pdp-custom-button-inner';
              
              const preorderLabel = document.createElement('span');
              preorderLabel.className = 'pdp-custom-value-lable';
              const preorderLabelText = document.body?.dataset?.notifyLabelPreorder || 'Pre-Order';
              preorderLabel.textContent = preorderLabelText;
              
              buttonInner.appendChild(preorderLabel);
              preorderLink.appendChild(buttonInner);
              pdpNotifyButton.appendChild(preorderLink);
              paymentCustomBtn.appendChild(pdpNotifyButton);
              
            } else {
              console.log(`🔔 Creating NOTIFY ME button for variant ${variant.id}`);
              
              // NOTIFY ME BUTTON
              const notifyMeVarintPopup = document.createElement('div');
              notifyMeVarintPopup.className = 'notify-me-varint-popup';
              
              const availableSoonSpan = document.createElement('span');
              availableSoonSpan.textContent = 'Available Soon!';
              notifyMeVarintPopup.appendChild(availableSoonSpan);
              
              const pdpNotifyButton = document.createElement('div');
              pdpNotifyButton.className = 'pdp-notify-button button button--full-width';
              
              const notifyLink = document.createElement('a');
              notifyLink.href = '#';
              notifyLink.className = 'notify_desktop-pdp-button product-form__buttons';
              notifyLink.dataset.productId = productData.id;
              notifyLink.dataset.variantId = variant.id;
              notifyLink.dataset.productTitle = productData.title;
              notifyLink.dataset.variantTitle = variant.title;
              notifyLink.dataset.variantSku = variant.sku || '';
              
              const buttonInner = document.createElement('div');
              buttonInner.className = 'pdp-custom-button-inner';
              
              const notifyLabel = document.createElement('span');
          
              
              buttonInner.appendChild(notifyLabel);
              notifyLink.appendChild(buttonInner);
              pdpNotifyButton.appendChild(notifyLink);
              notifyMeVarintPopup.appendChild(pdpNotifyButton);
              
              const notifyButton = document.createElement('button');
              notifyButton.type = 'button';
              notifyButton.className = 'btn btn--full notify-button notify-me';
              notifyButton.dataset.productId = productData.id;
              notifyButton.dataset.variantId = variant.id;
              notifyButton.dataset.productTitle = productData.title;
              notifyButton.dataset.variantTitle = variant.title;
              notifyButton.dataset.variantSku = variant.sku || '';
              notifyButton.dataset.notifyMe = '';
              
              const notifySpan = document.createElement('span');
              notifySpan.dataset.notifyText = '';
              notifySpan.textContent = 'Notify Me';
              
              notifyButton.appendChild(notifySpan);
              notifyMeVarintPopup.appendChild(notifyButton);
              
              paymentCustomBtn.appendChild(notifyMeVarintPopup);
            }
            
            label.appendChild(paymentCustomBtn);
          }
          
          const sizeSpan = document.createElement('span');
          sizeSpan.textContent = value;
          label.appendChild(sizeSpan);
    
          sizeContainer.appendChild(label);
        }
      });
      
      // Use setTimeout to ensure DOM is fully updated before attaching events
      setTimeout(() => {
        if (typeof initializeNotifyButtons === 'function') {
          initializeNotifyButtons(card);
        }
      }, 0);
    }
// Simplified initialization using event delegation at document level
function initializeNotifyButtons(container) {
  console.log('Initializing notify buttons for container:', container);
  
  // Use event delegation - attach to document instead of individual buttons
  document.addEventListener('click', function(event) {
    // Check if clicked element is a notify button or inside one
    const notifyButton = event.target.closest('.notify-button, .notify_desktop-pdp-button');
    console.log("notifyButton", notifyButton);  
    
    if (!notifyButton) return;
    
    // Check if this button is within our container
    if (container && !container.contains(notifyButton)) return;
    
    event.preventDefault();
    event.stopPropagation();
    
    console.log('Notify button clicked via delegation');
    
    // Find the popup container
    let notifyPopup = null;
    
    if (isInsideProductSlider) {
      const searchDrawerNotifyPopup = document.querySelector('.notifyme_popup_container.search-drawer');
      if (searchDrawerNotifyPopup) {
        notifyPopup = searchDrawerNotifyPopup;
 
        const productItem = notifyButton.closest('.grid-product__content') || notifyButton.closest('.grid-product');
        const originalImg = productItem ? productItem.querySelector('img') : null;
        const popupImg = notifyPopup.querySelector('img.popup-product-image') || notifyPopup.querySelector('.product-image img') || notifyPopup.querySelector('img');
 
        if (originalImg && popupImg) {
          popupImg.src = originalImg.currentSrc || originalImg.src;
          if (originalImg.srcset) popupImg.srcset = originalImg.srcset;
        }                
      }
    }
 
 
    const gridProductContent = notifyButton.closest('.grid-product__content');  
    if (gridProductContent && !notifyPopup) {
      notifyPopup = gridProductContent.querySelector('.notifyme_popup_container');
      console.log("Collection page structure - looking for notify popup");
    }
 
    if (!notifyPopup) {
      const paymentCustomBtn = notifyButton.closest('.payment_custom_btn');
      if (paymentCustomBtn) {
        notifyPopup = paymentCustomBtn.querySelector('.notifyme_popup_container');
        console.log("Product page structure detected");
      }
    }
    
    // If still not found, search in the entire card
    if (!notifyPopup && container) {
      notifyPopup = container.querySelector('.notifyme_popup_container');
      console.log("Searching in card container");
    }
    
    // Last resort - search entire document
    if (!notifyPopup) {
      notifyPopup = document.querySelector('.notifyme_popup_container');
      console.log("Using document-level popup");
    }
    
    if (!notifyPopup) {
      console.error('Notify popup container not found');
      console.log('Button:', notifyButton);
      console.log('Container:', container);
      return;
    }
    
    console.log('Found popup:', notifyPopup);
    
    // Open popup
    notifyPopup.classList.add('active');
    notifyPopup.style.display = 'flex';
    document.body.classList.add('overlay_bulkpopup');
    
    const closePopupButton = notifyPopup.querySelector('.notify_close_popup');
    const thankYouMessage = notifyPopup.querySelector('#thank_you');
    const formState = notifyPopup.querySelector('.form-state, .notify-popup-scroller'); 
    
    if (thankYouMessage) thankYouMessage.style.display = 'none';
    if (formState) formState.style.display = 'block';
    if (closePopupButton) closePopupButton.style.display = 'block';
    
    const errorMessages = notifyPopup.querySelectorAll('.error-message');
    errorMessages.forEach(msg => msg.remove());
    const invalidFields = notifyPopup.querySelectorAll('.invalid');
    invalidFields.forEach(field => field.classList.remove('invalid'));
    
    const productId = notifyButton.getAttribute('data-product-id');
    const variantId = notifyButton.getAttribute('data-variant-id');
    const productTitle = notifyButton.getAttribute('data-product-title');
    const variantTitle = notifyButton.getAttribute('data-variant-title');
    
    console.log('Product data:', { productId, variantId, productTitle, variantTitle });
    
    const productNameElement = notifyPopup.querySelector('.product-title');
    if (productNameElement && productTitle) {
      productNameElement.textContent = productTitle.toUpperCase();
    }
    
    const notifyProductForm = formState?.querySelector('form#ContactForm-NotifyFun') || 
                              notifyPopup.querySelector('form#ContactForm-NotifyFun');
    
    if (notifyProductForm) {
      const pidInput = notifyProductForm.querySelector('input[name="contact[Product ID]"]');
      const vidInput = notifyProductForm.querySelector('input[name="contact[Variant ID]"]');
      const pnameInput = notifyProductForm.querySelector('input[name="contact[Product Name]"]');
      const vnameInput = notifyProductForm.querySelector('input[name="contact[Variant Name]"]');
      console.log("pidInput",pidInput,pnameInput)
      if (pidInput && productId) pidInput.value = productId;
      if (vidInput && variantId) vidInput.value = variantId;
      if (pnameInput && productTitle) pnameInput.value = productTitle;
      if (vnameInput && variantTitle) vnameInput.value = variantTitle;
    }
  }, true); // Use capture phase
}

// Helper functions for validation
function validateNotifyForm(form) {
  const previousErrors = form.querySelectorAll('.error-message');
  previousErrors.forEach(error => error.remove());
  
  const email = form.querySelector('[name="contact[email]"]');
  
  if (!email) {
    console.error('Required form fields not found');
    return false;
  }
  
  let isValid = true;
  
  if (email.value.trim() === '') {
    showError(email, 'Email is required');
    isValid = false;
  } else {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email.value.trim())) {
      showError(email, 'Please enter a valid email address');
      isValid = false;
    }
  }
  
  return isValid;
}

function showError(field, message) {
  field.classList.add('invalid');
  
  const fieldContainer = field.closest('.field');
  if (!fieldContainer) return;
  
  const existingError = fieldContainer.querySelector('.error-message');
  if (existingError) {
    existingError.textContent = message;
    return;
  }
  
  const errorElement = document.createElement('div');
  errorElement.className = 'error-message';
  errorElement.style.color = 'red';
  errorElement.style.fontSize = '12px';
  errorElement.style.marginTop = '4px';
  errorElement.textContent = message;
  
  fieldContainer.appendChild(errorElement);
}
  
    // Function to attach event listeners to size options
    function attachSizeListeners(card) {
      const sizeLabels = card.querySelectorAll('.size-label');

      sizeLabels.forEach((size) => {
        // Remove any existing listener to prevent duplicates
        size.replaceWith(size.cloneNode(true));
      });

      // Re-query after cloning
      card.querySelectorAll('.size-label').forEach((size) => {
        size.addEventListener('click', function (e) {
          const now = Date.now();
          console.log("clickeddd")
          if (now - lastClickTime < 800) return; // prevent double adds
          lastClickTime = now;

          const label = e.currentTarget;
          if (label.classList.contains('out-of-stock')) return;
          console.log("label",label)
          const variantId = label.dataset.variantId;
          if (!variantId) return;

          const sizeOptions = label.closest('.size-options');
          sizeOptions?.querySelectorAll('.size-label').forEach((l) => l.classList.remove('selected'));
          label.classList.add('selected');

          console.log('Adding variant to cart:', variantId);

          // Use the globally exposed addToCart function
          if (window.cartUtils && typeof window.cartUtils.addToCart === 'function') {
            window.cartUtils.addToCart(variantId, 1);
          } else {
            console.error('Cart utilities not loaded yet');
          }
        });
      });
    }

    function formatMoney(cents) {
      // Basic money formatting - adjust based on your currency settings
      return '₹ ' + (cents / 100).toLocaleString('en-IN');
    }
  });
document.addEventListener('DOMContentLoaded', function() {
  console.log("swiper ini")
    new Swiper('.product-swiper', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1,
      spaceBetween: 10,
    });
  });
document.addEventListener('DOMContentLoaded', function() {
  console.log("swiper ini")
    new Swiper('.product-swiper', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1,
      spaceBetween: 10,
    });
  });
function initializeGridProductSwipers(context = document) {
  const scope =
    context instanceof Element || context instanceof DocumentFragment
      ? context
      : document;

  const swiperElements = scope.querySelectorAll
    ? scope.querySelectorAll('.grid-product-swiper')
    : document.querySelectorAll('.grid-product-swiper');

  swiperElements.forEach((swiperElement) => {
    if (
      swiperElement.classList.contains('swiper-initialized') ||
      swiperElement.swiper
    ) {
      return;
    }

    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 5,
      loop: true,
      navigation: {
        nextEl: swiperElement.querySelector('.swiper-button-next'),
        prevEl: swiperElement.querySelector('.swiper-button-prev'),
      },
    });
  });
}

function scheduleGridProductSwiperInit(context) {
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => requestAnimationFrame(() => initializeGridProductSwipers(context)),
      { once: true }
    );
    return;
  }

  requestAnimationFrame(() => initializeGridProductSwipers(context));
}

document.addEventListener('DOMContentLoaded', () => {
  scheduleGridProductSwiperInit();
});

document.addEventListener('shopify:section:load', (event) => {
  scheduleGridProductSwiperInit(event.target);
});

window.addEventListener('collectionUpdated', () => {
  scheduleGridProductSwiperInit();
});

document.addEventListener('collection:updated', () => {
  scheduleGridProductSwiperInit();
});

document.addEventListener('collection:filter:refresh', () => {
  scheduleGridProductSwiperInit();
});

const gridSwiperObserver = new MutationObserver((mutations) => {
  const hasNewSwiper = mutations.some((mutation) =>
    Array.from(mutation.addedNodes).some((node) => {
      if (node.nodeType !== 1) {
        return false;
      }

      if (node.classList?.contains('grid-product-swiper')) {
        return true;
      }

      return node.querySelector?.('.grid-product-swiper');
    })
  );

  if (hasNewSwiper) {
    scheduleGridProductSwiperInit();
  }
});

const gridSwiperRoot = document.querySelector(
  '.template-collection, .collection, main'
);

if (gridSwiperRoot) {
  gridSwiperObserver.observe(gridSwiperRoot, {
    childList: true,
    subtree: true,
  });
}
document.addEventListener("DOMContentLoaded", () => {
const radio = document.querySelector('input[data-variant-id]:checked');  
if(radio){
  console.log("radio",radio)
radio.dispatchEvent(new Event("change", { bubbles: true })); 
}
});
document.addEventListener('DOMContentLoaded', function() {
  const stickyATC = document.querySelector('.floating-cart.sticky-atc');
  if(stickyATC){
  const addToCartBtn = stickyATC.querySelector('.add-to-cart');
  const buyNowBtn = stickyATC.querySelector('.buy-now');
  
  // Show/hide sticky ATC on scroll
  let lastScrollTop = 0;
  const triggerPoint = 500; // Show after scrolling 500px
  
  window.addEventListener('scroll', function() {
    // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Show sticky ATC when scrolling down past trigger point
    // if (scrollTop > triggerPoint) {
      stickyATC.classList.add('visible');
    // } else {
      // stickyATC.classList.remove('visible');
    // }
    
    // lastScrollTop = scrollTop;
  });
  
  // Buy Now functionality
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function(e) {
      e.preventDefault();
      buyBtn = document.querySelector('#gokwik-buy-now[data-buy-cart]'); 
      if(buyBtn){
        console.log("buyBtn",buyBtn)  
        buyBtn.click();
        return;
      }      
      const variantId = this.getAttribute('data-curr-id');
      
      // Add to cart and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Added to cart:', data);
        // Redirect to checkout
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Error processing request. Please try again.');
      });
    });
  }
}
});

document.addEventListener('DOMContentLoaded', function () {
	
  console.log('✅ View switcher initialized');

  // -----------------------------
  // 🔁 Function to initialize or reinitialize view switcher
  // -----------------------------
  function initViewSwitcher() {
    console.log('🚀 Initializing view switcher');

    // Apply view layout (large / medium / small)
    function applyView(view) {
      console.log('🔄 Applying view:', view);

      const grid = document.querySelector('.grid--uniform');
      if (!grid) {
        console.warn('⚠️ No grid found');
        return;
      }

      const gridItems = grid.querySelectorAll('.grid__item');
      console.log('📊 Grid items:', gridItems.length);

      gridItems.forEach((item) => {
        item.classList.remove(
          'medium-up--one-half',
          'small--one-half',
          'medium-up--one-quarter',
          'small--one-third',
          'medium-up--one-sixth'
        );

        if (view === 'large') {
          item.classList.add('medium-up--one-half');
        } else if (view === 'medium') {
          item.classList.add('small--one-half', 'medium-up--one-quarter');
        } else {
          item.classList.add('small--one-third', 'medium-up--one-sixth');
        }
      });

      console.log('✅ View applied:', view);
    }

    // Attach click listeners to view buttons
    const viewButtons = document.querySelectorAll('.view-switcher__btn');
    if (viewButtons.length === 0) {
      console.warn('⚠️ No view buttons found');
      return;
    }

    viewButtons.forEach((btn) => {
      btn.removeEventListener('click', onViewButtonClick); // Prevent duplicate listeners
      btn.addEventListener('click', onViewButtonClick);
    });

    // Separate function for clarity
    function onViewButtonClick() {
      const viewButtons = document.querySelectorAll('.view-switcher__btn');
      viewButtons.forEach((b) => b.classList.remove('active'));
      this.classList.add('active');

      const selectedView = this.getAttribute('data-view');
      applyView(selectedView);
    }

    console.log('✅ View switcher buttons initialized');
  }

  // -----------------------------
  // 🔁 Run on page load
  // -----------------------------
  initViewSwitcher();

  // -----------------------------
  // 🔁 Re-run when Shopify dynamically reloads sections
  // -----------------------------
  document.addEventListener('shopify:section:load', function () {
    console.log('♻️ Shopify section reloaded — reinitializing view switcher');
    initViewSwitcher();
  });

  // -----------------------------
  // 🔁 Re-run when your custom AJAX filter updates the collection
  // -----------------------------
  window.addEventListener('collectionUpdated', function () {
    console.log('🔔 Collection updated via AJAX — reinitializing view switcher');
    initViewSwitcher();
  });

  // -----------------------------
  // 👀 Backup: Mutation observer (detects grid reloads)
  // -----------------------------
  const observer = new MutationObserver((mutations) => {
    const hasGridChanges = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.classList?.contains('grid__item') ||
            node.querySelector?.('.grid__item') ||
            node.classList?.contains('grid--uniform'))
      )
    );

    if (hasGridChanges) {
      console.log('👀 Grid mutation detected — reinitializing view switcher');
      setTimeout(initViewSwitcher, 200);
    }
  });

  const mainContent = document.querySelector('.template-collection, .collection, main, body');
  if (mainContent) {
    observer.observe(mainContent, { childList: true, subtree: true });
    console.log('👀 Mutation observer active');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  console.log("Size variant cart functionality loaded");

  // Prevent duplicate script initialization
  if (window.sizeVariantCartInitialized) {
    console.log("Script already initialized, skipping");
    return;
  }
  window.sizeVariantCartInitialized = true;

  /* -----------------------------
     DESKTOP CART NOTIFICATION POPUP
  ----------------------------- */
  if(window.innerWidth >= 768){
    function createCartNotification() {  
      if (document.getElementById('cart-notification-popup')) return;

      const overlay = document.createElement('div');
      overlay.className = 'cart-notification-overlay';
      overlay.id = 'cart-notification-overlay';

      const popup = document.createElement('div');
      popup.className = 'cart-notification-popup';
      popup.id = 'cart-notification-popup';
      popup.style.display = 'block'
      popup.innerHTML = `
        <div class="cart-notification-header">
          <h3>
          <span class="cart-notification-icon">
            <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.75 4.75L3.25 7.25L9.75 0.75" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
           ADDED TO BASKET</h3>
          <button class="cart-notification-close" type="button">×</button>
        </div>
        <div class="cart-notification-body" id="cart-notification-content"></div>
      `;

      document.body.appendChild(overlay);
      document.body.appendChild(popup);

      overlay.addEventListener('click', closeCartNotification);
      popup.querySelector('.cart-notification-close').addEventListener('click', closeCartNotification);
    }

    function closeCartNotification() {
      document.getElementById('cart-notification-overlay')?.classList.remove('active');
      document.getElementById('cart-notification-popup')?.classList.remove('active');
    }

    function showCartNotification(item, cart) {
      const overlay = document.getElementById('cart-notification-overlay');
      const popup = document.getElementById('cart-notification-popup');
      const content = document.getElementById('cart-notification-content');
      if (!overlay || !popup || !content) return;

      const formatMoney = cents => '₹ ' + (cents / 100).toLocaleString('en-IN');

      content.innerHTML = `
        <div class="cart-notification-product">
          <img src="${item.featured_image?.url || ''}" alt="${item.product_title}" class="cart-notification-image">
          <div class="cart-notification-details">
          <div class="cart-notification-title-wrapper">
              <div class="cart-notification-title">${item.product_title}</div>
              <div class="cart-notification-price">${formatMoney(item.final_line_price)}</div>
            </div>
            <div class="cart-notification-meta">Quantity: ${item.quantity}</div>
            ${item.variant_title ? `<div class="cart-notification-meta">Size: ${item.variant_title}</div>` : ''}
          </div>
        </div>
        <div class="cart-notification-summary">
          <div class="cart-notification-row">
            <span>SUBTOTAL</span><span>${formatMoney(cart.total_price)}</span>
          </div>
        </div>
        <div class="cart-notification-footer">
          <div id="gokwik-container">
      <div class="gokwik-checkout">
        <button type="button" class="disabled" disabled onclick="onCheckoutClick(this)">
          <span class="btn-text">
            <span>CHECKOUT</span>
          </span>
          <span class="pay-opt-icon"></span>
          <div style="display:none" class="addloadr" id="btn-loader">
            <div class="cir-loader">Loading..</div>
          </div>
        </button>
      </div>
    </div>
          <button class="cart-notification-btn secondary" onclick="window.location.href='/cart'">VIEW BAG (${cart.item_count})</button>
        </div>
      `;

      overlay.classList.add('active');
      popup.classList.add('active');
      setTimeout(closeCartNotification, 10000);
    }

    /* -----------------------------
       ADD TO CART (DESKTOP VERSION)
    ----------------------------- */
    function addToCart(variantId, quantity) {
      console.log('addToCart called with:', variantId, quantity);
      
      // Prevent multiple simultaneous requests
      if (window.addingToCart) {
        console.log('Already adding to cart, please wait');
        return;
      }
      
      window.addingToCart = true;
      
      // First, get current cart to check if item exists
      fetch('/cart.js')
        .then(res => res.json())
        .then(currentCart => {
          // Check if this variant already exists in cart
          const existingItem = currentCart.items.find(item => item.variant_id == variantId);
          console.log("existingItem", existingItem);
          
          if (existingItem) {
            // If exists, update the quantity
            const newQuantity = existingItem.quantity + quantity;
            
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: variantId,
                quantity: newQuantity
              })
            });
          } else {
            // If doesn't exist, add new item
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: variantId, quantity }]
              })
            });
          }
        })
        .then(res => res.json())
        .then(() => fetch('/cart.js'))
        .then(res => res.json())
        .then(cart => {
          console.log('Cart updated successfully:', cart);
      if(addToCartButton){

           addToCartButton.disabled = false;
          addToCartButton.classList.remove('btn--loading');
      }
          const addedItem = cart.items.find(item => item.variant_id == variantId);
          if (window.location.pathname === '/cart') {
            location.reload();
          } else {
            showCartNotification(addedItem, cart);
          }
          updateCartCount(cart.item_count);
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
          alert('Error adding product to cart. Please try again.');
        })
        .finally(() => {
          window.addingToCart = false;
        });
    }

    // Initialize notification
    createCartNotification();
  }
  else {
    function createMobileToast() {
      if (document.getElementById('mobile-cart-toast')) return;

      const toast = document.createElement('div');
      toast.className = 'mobile-cart-toast';
      toast.id = 'mobile-cart-toast';
      toast.innerHTML = `
        <div class="mobile-toast-content">
          <span class="mobile-toast-text">ITEM ADDED TO SHOPPING BAG</span>
          <span class="close-icon">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg>
          </span>
        </div>
      `;

      document.body.appendChild(toast);
    }

    function showMobileToast(cartCount) {
      const toast = document.getElementById('mobile-cart-toast');
      
      if (toast) {
        // Show toast
        toast.classList.add('show');
        
        // Hide after 4 seconds
        setTimeout(() => {
          toast.classList.remove('show');
        }, 4000);
      }
    }

    function closeCartNotification() {
      // Placeholder for mobile (not used but needed for compatibility)
    }

    function showCartNotification(item, cart) {
      // On mobile, show toast instead
      showMobileToast(cart.item_count);
    }

    /* -----------------------------
       ADD TO CART (MOBILE VERSION)
    ----------------------------- */
    function addToCart(variantId, quantity) {
      if(addToCartButton){

      addToCartButton.disabled = true;
      addToCartButton.classList.add('btn--loading');
      }
      console.log('addToCart called with mobile:', variantId, quantity);
      
      // Prevent multiple simultaneous requests
      if (window.addingToCart) {
        console.log('Already adding to cart, please wait');
        return;
      }
      
      window.addingToCart = true;
      
      // First, get current cart to check if item exists
      fetch('/cart.js')
        .then(res => res.json())
        .then(currentCart => {
          // Check if this variant already exists in cart
          const existingItem = currentCart.items.find(item => item.variant_id == variantId);
          console.log("existingItem", existingItem);
          
          if (existingItem) {
            // If exists, update the quantity
            const newQuantity = existingItem.quantity + quantity;
            
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: variantId,
                quantity: newQuantity
              })
            });
          } else {
            // If doesn't exist, add new item
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: variantId, quantity }]
              })
            });
          }
        })
        .then(res => res.json())
        .then(() => fetch('/cart.js'))
        .then(res => res.json())
        .then(cart => {
          console.log('Cart updated successfully:', cart);
      if(addToCartButton){

          addToCartButton.disabled = false;
          addToCartButton.classList.remove('btn--loading');
      }
         if (window.location.pathname === '/cart') {
        location.reload();
      } 
       else{
          showMobileToast(cart.item_count);

         }
          updateCartCount(cart.item_count);
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
          alert('Error adding product to cart. Please try again.');
        })
        .finally(() => {
          window.addingToCart = false;
        });
    }

    // Initialize mobile toast
        createMobileToast(); 
  }

  /* -----------------------------
     SHARED FUNCTION
  ----------------------------- */
  function updateCartCount(count) {
    // Update cart count elements
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
      el.textContent = count;
    });
    
    // Update header cart bubble
    const cartBubble = document.querySelector('.cart-link__bubble');
    if (cartBubble) {
      if (count > 0) {
        cartBubble.textContent = count;
        cartBubble.classList.add('cart-link__bubble--visible');
      } else {
        cartBubble.textContent = '';
        cartBubble.classList.remove('cart-link__bubble--visible');
      }
    }
    
    // Update mobile footer badge
    const mobileBadge = document.querySelector('.mobile-bottom-nav__badge');
    const mobileCartWrapper = document.querySelector('.mobile-bottom-nav__cart-wrapper');
    if (mobileCartWrapper) {
      if (count > 0) {
        if (mobileBadge) {
          mobileBadge.textContent = count;
        } else {
          // Create badge if it doesn't exist
          const newBadge = document.createElement('span');
          newBadge.className = 'mobile-bottom-nav__badge';
          newBadge.textContent = count;
          mobileCartWrapper.appendChild(newBadge);
        }
      } else {
        // Remove badge if count is 0
        if (mobileBadge) {
          mobileBadge.remove();
        }
      }
    }
  }

  /* -----------------------------
     EXPOSE FUNCTIONS GLOBALLY
  ----------------------------- */
  window.cartUtils = {
    addToCart: addToCart,
    showCartNotification: showCartNotification,
    closeCartNotification: closeCartNotification,
    updateCartCount: updateCartCount
  };

  /* -----------------------------
     SIZE CLICK HANDLER
  ----------------------------- */
  // Prevent accidental double-click adds
  let lastClickTime = 0;
  let processingClick = false;

  const sizeLabels = document.querySelectorAll('.size-label');
  console.log("sizeLabels", sizeLabels.length);
  
  sizeLabels.forEach(size => {
    size.addEventListener('click', e => {
      console.log("clicked");
      
      // Prevent rapid successive clicks
      const now = Date.now();
      if (processingClick || (now - lastClickTime < 1000)) {
        console.log("Click ignored - too soon after last click");
        return;
      }
      
      lastClickTime = now;
      processingClick = true;

      const label = e.currentTarget;
      console.log("label", label);
      
      if (label.classList.contains('out-of-stock')) {
        processingClick = false;
        return;
      }

      const variantId = label.dataset.variantId;
      if (!variantId) {
        processingClick = false;
        return;
      }

      const sizeOptions = label.closest('.size-options');
      sizeOptions?.querySelectorAll('.size-label').forEach(l => l.classList.remove('selected'));
      label.classList.add('selected');

      console.log('Adding variant to cart:', variantId);
      addToCart(variantId, 1);
      
      // Reset processing flag after a short delay
      setTimeout(() => {
        processingClick = false;
      }, 1000);
    });
  });
});
// ---- HOVER HANDLERS ----
function productMouseover(evt) {
  const el = evt.currentTarget;
  el?.querySelector('.size-options')?.classList.add("options-active");  

  if (typeof theme !== 'undefined' && !theme.config.bpSmall) {
    if (!el || !el.dataset.productId) return; 
    const productId = el.dataset.productId;
    const handle = el.dataset.productHandle;
    const btn = el.querySelector('.quick-product__btn');

    if (theme.preloadProductModal) {
      theme.preloadProductModal(handle, productId, btn);
    }
  }
}

function productMouseout(evt) {
  const el = evt.currentTarget;
  const sizeOptions = el?.querySelector('.size-options');

  if (sizeOptions && !sizeOptions.matches(':hover')) {
    sizeOptions.classList.remove("options-active");
  }
}

// ---- EVENT DELEGATION FOR CLICK (works automatically with AJAX) ----
// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('.size-options-btn, .select-btn');
//   if (btn) {
//     e.stopPropagation();

//     const product = btn.closest('.grid-product__content');
//     const sizeOptions = product?.querySelector('.size-options');

//     if (!sizeOptions) return;

//     // Close other open ones
//     document.querySelectorAll('.size-options.options-active').forEach(opt => {
//       if (opt !== sizeOptions) opt.classList.remove('options-active');
//     });

//     // Toggle the active class
//     sizeOptions.classList.toggle('options-active');

//     console.log(
//       sizeOptions.classList.contains('options-active')
//         ? 'Class added'
//         : 'Class removed'
//     );
//   }
// });

// ---- FUNCTION TO ATTACH HOVER LISTENERS ----
function attachProductHoverListeners() {
  console.log("Attaching product hover listeners");
  
  // Only on desktop
  if (window.innerWidth < 768) return;

  const products = document.querySelectorAll('.grid-product__content');
  
  products.forEach(product => {
    // Skip if already has listeners
    if (product.dataset.hoverInitialized === 'true') return;
    
    product.addEventListener('mouseover', productMouseover);
    product.addEventListener('focusin', productMouseover);
    product.addEventListener('mouseout', productMouseout);
    product.addEventListener('focusout', productMouseout);
    
    product.dataset.hoverInitialized = 'true';
  });
  
  console.log(`Hover listeners attached to ${products.length} products`);
}

// ---- INITIALIZE ON PAGE LOAD ----
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachProductHoverListeners);
} else {
  attachProductHoverListeners();
}

// ---- AUTO-DETECT AJAX UPDATES ----
const observer = new MutationObserver(function(mutations) {
  let shouldReinit = false;
  
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList?.contains('grid-product') || 
              node.classList?.contains('grid-product__content') ||
              node.querySelector?.('.grid-product__content')) {
            shouldReinit = true;
          }
        }
      });
    }
  });
  
  if (shouldReinit) {
    setTimeout(attachProductHoverListeners, 100);
  }
});

// Start observing
const productContainer = document.querySelector('.product-grid, .collection-grid, [data-collection-container], .grid--uniform, main');
if (productContainer) {
  observer.observe(productContainer, {
    childList: true,
    subtree: true
  });
}

// ---- EXPOSE GLOBALLY FOR MANUAL CALLS ----
window.reinitProductHovers = attachProductHoverListeners;

// ---- HANDLE WINDOW RESIZE ----
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    // Remove all existing listeners and reattach based on screen size
    document.querySelectorAll('.grid-product__content').forEach(product => {
      product.dataset.hoverInitialized = 'false';
    });
    attachProductHoverListeners();
  }, 250);
});

  
document.addEventListener('DOMContentLoaded', () => {
  console.log("loaded");

  const items = document.querySelectorAll('.grid__item .grid__item-image-wrapper');
  console.log("items", items);

  // Create an intersection observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log("entry.target", entry.target);

        const images = entry.target.querySelectorAll('image-element');

        if (images.length > 0) {
          images.forEach(img => {
            img.classList.add('aos-animate');
          });
        }

        observer.unobserve(entry.target); // Stop observing once animated
      }
    });
  }, { threshold: 0.2 }); // Trigger when 20% visible

  items.forEach(item => observer.observe(item));
});



$(document).ready(function () {
	if (__st.pageurl.split('/')[1] == 'cart') {
		// sticky checkout btn
		let checkoutBtn = document.querySelector('.mobile_show .cart-raw .cart__checkout');
		if (checkoutBtn && window.innerWidth <= 767) {
			let giftCardContent = document.querySelector('.gift-checkout-inner');
			let checkoutBtnObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						giftCardContent.classList.remove('active');
					} else {
						giftCardContent.classList.add('active');
					}
				});
			})
			checkoutBtnObserver.observe(checkoutBtn);
		}
	}
	if (__st.pageurl.split('/')[1] == 'products') {
		let paymentBtn = document.querySelector('.product-single__meta .product-single__form');
		let mobilePayment = document.querySelector('.mobile_sticky_btn');
		if (mobilePayment && paymentBtn && window.innerWidth <= 767) {
			let mobileBtnObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						mobilePayment.classList.remove('active');
					} else {
						mobilePayment.classList.add('active');
					}
				});
			})
			mobileBtnObserver.observe(paymentBtn);


			mobilePayment.querySelector('.btn_mobile_atc').addEventListener('click', function () {
				paymentBtn.querySelector('[data-add-to-cart]').click();
			});
			mobilePayment.querySelector('.shopify-payment-button_mobile').addEventListener('click', function () {
				paymentBtn.querySelector('#flo-buy-now-button').click();
			});
		}
		if (window.innerWidth >= 1024) {
			$('.template-product .color-swatch').mouseenter(function () {
				let imgUrl = $(this).attr('data-imgurl');
				$('.product__main-photos .hovered-img').css({
					'opacity': '1',
					'background-repeat': 'no-repeat',
					'background-size': 'cover',
					'backgroundImage': `url(${imgUrl})`
				})
			}).mouseleave(function () {
				$('.product__main-photos .hovered-img').css('opacity', '0');
			});
		}
	}

	var customCheckout = document.querySelector('.custom_checkout');
	if(customCheckout){
		$(document).on('click', '.custom_checkout', function () {
			var var_id = $('[name="id"]').val();
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: { id: var_id, quantity: 1 },
				success: function (res) {
					window.location.href = '/cart';
				}
			});
		});
	}

	// discount-code js
	document.querySelectorAll('.success-msg-main').forEach(success => {
		success.style.display = "none";
	})
	var discountcODE = document.querySelectorAll('.discount-code-desc-inner');
	if(discountcODE){
		discountcODE.forEach(offer => {
			offer.addEventListener('click', (e) => {
				var current = e.currentTarget;
				var nextcurrent = e.currentTarget.nextElementSibling;
				var loaderclass = e.currentTarget.previousElementSibling;
				var discount_code = e.currentTarget.getAttribute('data-id');
				loaderclass.style.display = "flex";
				current.style.display = "none";
				fetch(`/discount/${discount_code}`, {
					method: 'GET',
				})
					.then(response => {
						loaderclass.style.display = "none";
						current.style.display = "none";
						nextcurrent.style.display = "flex";
						setTimeout(function () {
							current.style.display = "block";
							nextcurrent.style.display = "none";
						}, 4000);
					})
			})
		}
		)
	}

	// if cart is empty then show a new-drawer
	let isCart = document.querySelectorAll('.bottom-navigation-main .bottom-nav-block-heading h4');
	if (isCart) {
			isCart.forEach((innerValue) => {
					if (innerValue.textContent === 'Cart' || innerValue.textContent === 'cart') {
							let cartBtn = innerValue.closest('.bottom-nav-blocks');
							let emptyDrawer = document.querySelector('.cart_items_count');
							if (emptyDrawer) {
									let cart_items_count = document.body.getAttribute('data-cart-item-count');
									if (cart_items_count == 0) {
											cartBtn.addEventListener('click', (e) => {
													e.preventDefault();
													e.stopPropagation();
													emptyDrawer.classList.add('show_drawer_popup');
													document.body.classList.add('mini-cart--open');
											});
									}
							}
					}
			})
	}

	// close empt cart-drawer
	let closeBtn = document.querySelector('.empty_drawer__close_btn');
	if (closeBtn) {
			closeBtn.addEventListener('click', (e) => {
					closeBtn.closest('.cart_items_count').classList.remove('show_drawer_popup');
					document.body.classList.remove('mini-cart--open');
			});
	}

	// desktop cart is empty drawer
	let mainCartBtn = document.querySelector('.js-drawer-open-cart');
	if (mainCartBtn) {
			let cart_items_count = document.body.getAttribute('data-cart-item-count');
			if (cart_items_count == 0) {
					let emptyDrawer = document.querySelector('.cart_items_count');
					if (emptyDrawer) {
							mainCartBtn.addEventListener('click', (e) => {
									e.preventDefault();
									e.stopPropagation();
									emptyDrawer.classList.add('show_drawer_popup');
									document.body.classList.add('mini-cart--open');
							})
					}
			}
	};

	const frenchise_form_state = document.querySelector('.new-from-page-from-form');
	if (frenchise_form_state) {
		const frenchiseSend = frenchise_form_state.querySelector('#frenchisesendButton'),
			frenchiseForm = frenchise_form_state.querySelector('#ContactForm-frenchiseForm');
		frenchisethankYouMessage = document.getElementById('frenchise_thank_you'),
			frenchiseClose = document.querySelector('.frenchise_close_btn'),
			fields = frenchise_form_state.querySelectorAll('input,textarea');

		fields.forEach(field => {
			field.addEventListener('blur', validateField);
		});

		function validateField(event) {
			const field = event.target;
			const errorSpan = field.closest('.field').querySelector('.form-err-msg');
			var errorMessage = '';
			switch (field.name) {
				case 'contact[Name]':
					if (field.value.trim() === '') {
						errorMessage = 'Name field is required';
					}
					break;
				case 'contact[email]':
					if (field.value.trim() === '') {
						errorMessage = 'Email field is required';
					} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
						errorMessage = 'Invalid email address';
					}
					break;
				case 'contact[Phone number]':
					if (field.value.trim() === '') {
						errorMessage = 'phone field is required';
					}
					else if (!/^\d{10}$/.test(field.value)) {
						errorMessage = 'Phone number must be 10 digits';
					}
					break;
				case 'contact[Location name]':
					if (field.value.trim() === '') {
						errorMessage = 'Location name is required';
					}
					break;
				case 'contact[Message]':
					if (field.value.trim() === '') {
						errorMessage = 'Message is required';
					}
					break;
				default:
					console.log('Default case');
					break;
			}
			errorSpan.textContent = errorMessage;
		}

		if (frenchiseClose) {
			frenchiseClose.addEventListener("click", function (event) {
				event.preventDefault();
				frenchisethankYouMessage.style.display = "none";
				document.body.classList.remove("overlay_frenchisepopup");
				bulkProductForm.submit();
			});
		}

		frenchiseSend.addEventListener('click', function (event) {
			event.preventDefault();
			const username = frenchise_form_state.querySelector('[name="contact[Name]"]').value,
				mobile_number = frenchise_form_state.querySelector('[name="contact[Phone number]"]').value,
				email = frenchise_form_state.querySelector('[name="contact[email]"]').value,
				locationname = frenchise_form_state.querySelector('[name="contact[Location name]"]').value,
				message = frenchise_form_state.querySelector('[name="contact[Message]"]').value;

			if (username.trim() === '' || mobile_number.trim() === '' || email.trim() === '' || locationname.trim() === '' || message.trim() === '') {
				alert('Please fill out all fields');
				return false;
			}
			const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
			if (!emailPattern.test(email)) {
				alert('Please enter a valid email address');
				return false;
			}

			const mobilePattern = /^\d{10}$/;
			if (!mobilePattern.test(mobile_number)) {
				alert('Please enter a valid 10-digit mobile number');
				return false;
			}

			frenchiseSend.classList.add('loading');
			fetch('https://cpanel.mensabrands.com/BulkOrder/public/addFranchiseData', {
				method: "POST",
				headers: {
					"Accept": "application/json",
					"Content-type": "application/json",
					"Authorization": `Bearer ${window.sessionToken}`
				},
				body: JSON.stringify({
					user_name: username,
					mobile_number: mobile_number,
					email: email,
					location_name: locationname,
					message: message
				})
			})
				.then(res => {
					setTimeout(() => {
						frenchiseForm.submit();
						document.body.classList.remove("overlay_frenchisepopup");
					}, 5000);
				 	frenchisethankYouMessage.style.display = 'flex';
					document.body.classList.add("overlay_frenchisepopup");
					frenchiseSend.classList.remove('loading');
				})
		});
	}

	// Accordian
	$(document).on('click', '.cust-accordion .acco-title', function (e) {
	console.log("clicked")
	e.preventDefault();

	$(this).toggleClass('active').siblings('.acco-content').slideToggle();

	if ($(this).closest('.cust-accordion').hasClass('size-chart-acco-wrapper')) {
		let size_chart_index = document.querySelector('.size-chart-index');
		if (size_chart_index) {
		size_chart_index.classList.add('active');
		}

		if (typeof gtag === 'function') {
		gtag("event", "size_chart_btn_hit", {
			page_location: window.location.href
		});
		}
	}
	});


	$('.spr-badge[data-rating="0.0"]').parent('.product-block').hide();

	$('body').delegate(".read-more-filters", 'click', (e) => {
		$(e.currentTarget).hide();
		$(e.currentTarget).parent().addClass('hide-li');

	});

	// mobile footer colleps script
	if (window.innerWidth <= 768) {
		$('[data-type="menu"] .footer__title').siblings('div').hide();
		$('[data-type="menu"] .footer__title').click(function () {
			$(this).toggleClass('active').siblings('div').slideToggle(250);
		})
	}
});

window.theme = window.theme || {};

theme.sizeVariantRedirect = () => {
 	// add product grid variant to localstorage
	 const prd_Recom = document.querySelector('[data-section-type="product-recommendations"]');
 	if (prd_Recom) {
		// this function executes if dynamic data is loaded
		function onProductGridLoaded(elements) {
			if (elements) {
				elements.forEach((prdVar) => {
					prdVar.addEventListener('click', (event) => {
						event.preventDefault();
						let prdId = prdVar.closest('.grid__item').dataset.productId;
						let variantUrl = prdVar.getAttribute('data-navigation');
						let selectedValue = prdVar.getAttribute('data-var');
						if (prdId && selectedValue && variantUrl) {
									const items = {
									product_id: prdId,
								selected_var: selectedValue
							}
							const stringifiedObj = JSON.stringify(items)
							localStorage.setItem("prd_grid_variant", stringifiedObj);
							setTimeout(() => {
									window.location.href = variantUrl;
							}, 100);
						}
					})
				})
			}
		}

	const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
					if (mutation.addedNodes) {
							mutation.addedNodes.forEach((node) => {
									if (node.nodeType === 1) { // Ensure it's an element node
											const elements = node.querySelectorAll('.grid-overflow-wrapper .Size_var_wrap a');
											if (elements.length > 0) {
													onProductGridLoaded(elements);
													observer.disconnect();
											}
									}
							});
					}
			});
	});

	observer.observe(document.body, { childList: true, subtree: true, });
	}
	else {
		let prd_grid = document.querySelectorAll('.grid-product__content .Size_var_wrap a');
		if (prd_grid) {
				prd_grid.forEach((prdVar) => {
						prdVar.addEventListener('click', (event) => {
								event.preventDefault();
								let prdId = prdVar.closest('.grid__item').dataset.productId;
								let variantUrl = prdVar.getAttribute('data-navigation');
								let selectedValue = prdVar.getAttribute('data-var');
								if (prdId && selectedValue && variantUrl) {
										const items = {
												product_id: prdId,
												selected_var: selectedValue
										}
										const stringifiedObj = JSON.stringify(items)
										localStorage.setItem("prd_grid_variant", stringifiedObj);
										setTimeout(() => {
												window.location.href = variantUrl;
										}, 100);
								}
						})
				})
		}
	}
}

theme.sizesChart = () => {
	setTimeout(() => {
		const sizeChart = document.querySelectorAll('.sizeOnclicking');
		if (sizeChart) {
			sizeChart.forEach(function (item) {
				item.style.display = 'flex';
				item.addEventListener('click', function (e) {
					this.classList.add('active');
					var gridProductContent = e.currentTarget.closest('.grid-product__content');
					gridProductContent.querySelector('.size-infos').classList.add('show-popup', 'active');
					gridProductContent.querySelector('.overlay-popup').classList.add('active');
					document.body.classList.add('size_guide_open');
				});
			});
		}
	}, 2000);
	setTimeout(() => {
		const sizeClose = document.querySelectorAll('.close-icon');
		if (sizeClose) {
			sizeClose.forEach(function (item) {
				item.addEventListener('click', function (e) {
					var sizeInfos = e.currentTarget.closest('.size-infos');
					sizeInfos.classList.remove('active', 'show-popup');
					e.currentTarget.closest('.overlay-popup').classList.remove('active');
					e.currentTarget.closest('.overlay-popup').previousElementSibling.querySelector('.sizeOnclicking').classList.remove('active');
					document.body.classList.remove('size_guide_open');
				});
			});
		}
	}, 2000);
}

theme.sizesProductChart = () => {
	setTimeout(() => {
		if (window.innerWidth > 767 && __st.rtyp == 'product') {
			const sizeProductChart = document.querySelector('#sizevarTrigger');
			if (sizeProductChart) {
				sizeProductChart.style.display = 'flex';
				sizeProductChart.addEventListener('click', function (e) {
					e.currentTarget.classList.add('active');
					var gridsContent = e.currentTarget.closest('.product-section');
					gridsContent.querySelector('.size-infos').classList.add('show-popup', 'active');
					gridsContent.querySelector('.overlay-popup').classList.add('active');
					document.body.classList.add('size_guide_open');
				});
			}
		}
	}, 1000);
	setTimeout(() => {
		if (window.innerWidth > 767 && __st.rtyp == 'product') {
			const sizesClose = document.querySelector('.product-section .close-icon');
			if (sizesClose) {
				sizesClose.addEventListener('click', function (e) {
					var sizesInfos = e.currentTarget.closest('.size-infos');
					sizesInfos.classList.remove('active', 'show-popup');
					e.currentTarget.closest('.overlay-popup').classList.remove('active');
					e.currentTarget.closest('.product-section').querySelector('#sizevarTrigger').classList.remove('active');
					document.body.classList.remove('size_guide_open');
				});
			}
		}
	}, 1000);
}

theme.sticky = () => {
	let cartBtn = document.querySelector('.atc-wrapper button');
	if (cartBtn) {
		cartBtn.addEventListener('click', function () {
			let trigger = document.querySelector('.payment-buttons [data-add-to-cart]');
			trigger.click();
		})
	}
	var selectedDropdown = document.querySelector('#SingleOptionSelector');
	document.addEventListener("variant:change", (e) => {
		if (selectedDropdown) {
			selectedDropdown.value = e.detail.variant?.id;
		}
		var selDropdown = document.querySelector('.var_display .size_name');
		if (selDropdown) {
			selDropdown.innerHTML = e.detail.variant.option2;
		}   
	})

	if (selectedDropdown) {
		selectedDropdown.addEventListener("change", function (evt) {
			var variantJson = document.querySelector('[data-product-json]');
			var variantObject = JSON.parse(variantJson.innerHTML);
			var variantsArray = variantObject.variants;
			let filterVariant = variantsArray.filter(function (variant) {
				if (variant.id == evt.target.value) {
					return variant;
				}
			})
			// var OptionVal1 = filterVariant[0].option1;
			// if(OptionVal1 != 'null'){
			// 	// $(`[data-value="${OptionVal1}"] input`).trigger("click");
			// 	document.querySelector(`[data-value="${OptionVal1}"] input`).click();
			// }

			var OptionVal2 = filterVariant[0].option2;
			if (OptionVal2 != '') {
				document.querySelector(`[data-value="${OptionVal2}"] input`).click();
			}
			// var OptionVal3 = filterVariant[0].option3;
			// if(OptionVal3 != ''){
			//   document.querySelector(`[data-value="${OptionVal3}"] input`).click();
			// }

		});
	}

}

// slider
const slider = () => {
	var slideshowEle = document.querySelectorAll('.slider-wrapper');
	if (slideshowEle) {
		slideshowEle.forEach(current => {
			var swiperOptions = JSON.parse(current.dataset.sliderOptions);
			swiper = new Swiper(current, swiperOptions);

			current.addEventListener('mouseover', () => {
				swiper.autoplay.stop();
			})
			current.addEventListener('mouseleave', () => {
				swiper.autoplay.start();
			})

			// pause slideshow on block select
			if (Shopify.designMode) {
				document.addEventListener('shopify:block:select', (e) => {
					var shopifyData = JSON.parse(e.target.dataset.shopifyEditorBlock),
						targetEle = e.target,
						sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
					swiper.slideTo(sliderIndex);
					swiper.autoplay.stop();
				})
				const customizationEvents = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:block:deselect', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect', 'shopify:inspector:activate', 'shopify:inspector:deactivate'];

				customizationEvents.forEach(event => {
					document.addEventListener(event, () => swiper.init(swiperOptions));
				})
			}
		})
	}
}

theme.mobileSlider = () => {
	if (window.innerWidth <= 768) {
		var cacheHeight = 0;
		var newHeight = 0;
		setTimeout(() => {
			var ele = document.querySelectorAll('.swiper-slide.logo-bar__item .logo-bar__link');
			if (ele) {
				ele.forEach(element => {
					(element.offsetHeight > cacheHeight) ? cacheHeight = element.offsetHeight : cacheHeight = cacheHeight;
				});
				ele.forEach(element => {
					newHeight = (cacheHeight * 2) + 24;
					element.parentElement.parentElement.style.height = `${newHeight}px`
				})
			}
		}, 1000);
		// var mobileslideshowEle = document.querySelector('.mobile-slide-wrapper');
		// if (mobileslideshowEle) {
		// 	var mobileswiperOptions = JSON.parse(mobileslideshowEle.dataset.sliderOptions);
		// 	swiper = new Swiper(mobileslideshowEle, mobileswiperOptions);

		// 	// pause slideshow on block select
		// 	if (Shopify.designMode) {
		// 		document.addEventListener('shopify:block:select', (e) => {
		// 			var shopifyData = JSON.parse(e.target.dataset.shopifyEditorBlock),
		// 				targetEle = e.target,
		// 				sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
		// 			swiper.slideTo(sliderIndex);
		// 			swiper.autoplay.stop();
		// 		})
		// 		const customizationEvents = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:block:deselect', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect', 'shopify:inspector:activate', 'shopify:inspector:deactivate'];

		// 		customizationEvents.forEach(event => {
		// 			document.addEventListener(event, () => swiper.init(mobileswiperOptions));
		// 		})
		// 	}
		// }
	}
}

theme.sliderDesktop = () => {
	if (window.innerWidth > 768) {
		for (item of document.querySelectorAll('.desktop_slids .desktop_slids_inner > div'))
			item.style.scrollSnapAlign = 'center';

		const gallery = document.querySelectorAll('.desktop_slids');
		gallery.forEach(btn => {
			const gallery_scroller = btn.querySelector('.desktop_slids_inner');
			const gallery_item_size = gallery_scroller.querySelector('div').clientWidth;

			btn.querySelector('.btn.next').addEventListener('click', scrollToNextPage);
			btn.querySelector('.btn.prev').addEventListener('click', scrollToPrevPage);

			function scrollToNextPage() {
				gallery_scroller.scrollBy(gallery_item_size, 0);
			}
			function scrollToPrevPage() {
				gallery_scroller.scrollBy(-gallery_item_size, 0);
			}
		});

	}
}

// plp pagination
const infiniteScroll = () => {
	let cacheCount = 0;
	window.addEventListener('scroll', () => {
		let infiniteWrapperEle = document.querySelector('[data-next-page]');
		if (infiniteWrapperEle) {
			let offsetBottom = infiniteWrapperEle.getBoundingClientRect().bottom - window.innerHeight;
			let rootMargin = window.innerHeight * 2;
			if (offsetBottom <= rootMargin && cacheCount == 0) {
				cacheCount++;
				let url = infiniteWrapperEle.dataset.nextPage;
				if (url != "") {
					fetch(url)
						.then(res => res.text())
						.then(data => {
							cacheCount = 0;
							var dataHTML = new DOMParser().parseFromString(data, 'text/html');
							let productGrid = dataHTML.querySelector('[data-next-page]').innerHTML;

							infiniteWrapperEle.insertAdjacentHTML("beforeend", productGrid);

							infiniteWrapperEle.dataset.nextPage = dataHTML.querySelector('[data-next-page]').dataset.nextPage;
							theme.sizesChart();
							theme.sizeVariantRedirect();
							// window.history.pushState("Dennis lingo", "Dennis lingo", url);
							if (window.AOS) { AOS.refreshHard() }
						})
				} else {
					document.querySelector('.pagination-loader').style.display = "none";
				}
			}
		}
	})
}  
// custom dropdown
const customDropDown = () => {
	// Toggle dropdown - using event delegation on document
	document.addEventListener('click', (e) => {
		if (e.target.closest('.el-dropdown-btn')) {
			var dropDownBtn = e.target.closest('.el-dropdown-btn');
			var dropDownList = dropDownBtn.nextElementSibling;
			dropDownList.classList.toggle('active');
		}
	});

	// Apply/change value - using event delegation
	document.addEventListener('click', (e) => {
		if (e.target.closest('.el-dropdown-list li')) {
			let that = e.target.closest('.el-dropdown-list li');
			let inputField = that.closest('.el-dropdown-list').querySelector('input[type="hidden"]');
			that.closest('ul').querySelectorAll('li').forEach(input => input.classList.remove('active'));
			that.classList.add('active');
			inputField.value = that.getAttribute('value');
			inputField.dispatchEvent(new Event('change'));
		}
	});

	// Close mobile popup - using event delegation
	document.addEventListener('click', (e) => {
		if (e.target.closest('.el-dropdown .closePop, .el-dropdown .overlay')) {
			let that = e.target.closest('.el-dropdown .closePop, .el-dropdown .overlay');
			that.closest('.el-dropdown').querySelector('.el-dropdown-list').classList.remove('active');
		}
	});
}
window.addEventListener('DOMContentLoaded', () => {
	theme?.sections?.register('slideshow-section', theme.SlideshowSection);
	theme.sizeVariantRedirect();
	infiniteScroll();
	customDropDown();
	slider();
	theme.sticky();
	theme.mobileSlider();
	theme.sizesChart();
	theme.sizesProductChart();
	theme.sliderDesktop();

});



// Floating Cart Visibility Controller 
(function() {
  const floatingCart = document.querySelector('.floating-cart');
  const mainCart  = document.querySelector('.product-single__form [data-add-to-cart]');
  const notifyBtn = document.querySelector('.product-single__form [data-notify-me]');
 
  if (!floatingCart) return;
 
  function isElementVisible(element) {
    if (!element) return false;
 
    const rect = element.getBoundingClientRect();
    const winH = window.innerHeight || document.documentElement.clientHeight;
    const inViewport = rect.top < winH && rect.bottom > 0;
 
    const cs = window.getComputedStyle(element);
    const visibleCss = cs.display !== 'none';   
 
    return inViewport && visibleCss;
  }
 
  function toggleFloatingCart() {
    const mainVisible   = isElementVisible(mainCart);
    const notifyVisible = isElementVisible(notifyBtn);
 
    if (mainVisible || notifyVisible) {
      floatingCart.style.display = 'none';
    } else {
      floatingCart.style.display = 'block';
    }
  }
 
  toggleFloatingCart();
 
  let t;
  ['scroll','resize'].forEach(evt => {
    window.addEventListener(evt, () => {
      clearTimeout(t);
      t = setTimeout(toggleFloatingCart, 50);
    });
  });
  window.addEventListener('load', toggleFloatingCart);
})();
 